//變數
var logintype = true; //只顯示一次提示
var betcompare = (withdraw_limit = "");
var regneedpbrth = $('#check18y').val() ? $('#check18y').val() : 'N';
var today = new Date();
var last_week = new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000);
last_week = format_time(last_week);
var last_30days = format_time(new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000)) + " 00:00:00";
var startData = last_week + " 00:00:00";
var endData = format_time(today) + " 23:59:59";
var yesterday = new Date();
yesterday = yesterday.setDate(today.getDate() - 1);

var gamedata = "";
var getBalance_count;
var xfer_count;
var total_count;
var XferAllError = true;
var XferAllAlert = false;
var gameslist;
var demoplay = "";
var rulecondition = "";
var rulemsg = "";

function handlerPaginationClick () {
  $(".pagination li").on("click", function() {
    window.scroll({top: 0, behavior: 'smooth'});

    $(".pagination li").removeClass("active");
    $(this).addClass("active");
  })
}

// 基本解析函式
function format_time(time) {
  time =
    time.getFullYear() +
    "-" +
    headertimeformat(time.getMonth() + 1) +
    "-" +
    headertimeformat(time.getDate());
  return time;
}

function headertimeformat(time) {
  var format = "00" + time;
  format = format.substr(format.length - 2);
  return format;
}

function html_encode(str) {
  str = str.toString()
  var s = "";
  if (str.length == 0) return "";
  s = str.replace(/&/g, "&amp;");
  s = s.replace(/</g, "&lt;");
  s = s.replace(/>/g, "&gt;");
  s = s.replace(/ /g, "&nbsp;");
  s = s.replace(/\'/g, "&apos;");
  s = s.replace(/\"/g, "&quot;");
  s = s.replace(/\n/g, "<br>");
  return s;
}

function html_decode(str) {
  var s = "";
  if (str.length == 0) return "";
  s = str.replace(/&amp;/g, "&");
  s = s.replace(/&lt;/g, "<");
  s = s.replace(/&gt;/g, ">");
  s = s.replace(/&nbsp;/g, " ");
  s = s.replace(/&apos;/g, "'");
  s = s.replace(/&quot;/g, '"');
  s = s.replace(/<br>/g, "\n");
  return s;
}

function xfer_form_rest() {
  $("#transferform input").val("");
  $("#transferform select").val("");
  $("#transferfrom").change();
  $("#transferto").change();
}

// 手機號碼驗證（支援台灣、馬來西亞、香港、中國）
jQuery.validator.addMethod(
  "mobile",
  function (value, element) {
    var length = value.length;
    // 台灣: 09xxxxxxxx (10位), 馬來西亞: 01xxxxxxxx (10-11位), 香港: xxxxxxxx (8位), 中國: 1xxxxxxxxxx (11位)
    var mobile = /^(09[0-9]{8}|01[0-9]{8,9}|[2-9][0-9]{7}|1[3-9][0-9]{9})$/;
    return this.optional(element) || (length >= 8 && length <= 11 && mobile.test(value));
  },
  "請輸入有效的手機號碼!"
);

jQuery.validator.addMethod("withdrawLimitAmountRule", function(value, element) {
  const rulecondition = $("#AmountRuleRuleCondition").val();
  const regex = new RegExp(rulecondition.replace(/^\/|\/$/g, ''));
  return $("#sw_withdrawLimitSet").val() != 0 && $('#acc_id option:selected').data('exchange') == 1 ? !regex.test(value) :true;
}, $("#AmountRuleErrorMessage").val());

jQuery.validator.addMethod("ruleCondition", function(value, element) {
  try {
    if (rulecondition == '') {
      return true
    } else {
      const regex = new RegExp(rulecondition.replace(/^\/|\/$/g, ''));
      return !regex.test(value);
    }
  } catch (e) {
    swal(e.message, "", "error");
    return false;
  }
}, rulemsg);

// 身分證字號格式驗證 (支援多國格式)
jQuery.validator.addMethod(
  "passport",
  function (value, element) {
    // 取得對應的國家選擇欄位（支援 select 和 hidden input）
    var $form = $(element).closest('form');
    var countryField = $form.find('select[name="pid_country"], input[name="pid_country"], select[name="usdt_pid_country"], input[name="usdt_pid_country"]');
    var country = countryField.length > 0 ? countryField.val() : 'TW';

    var patterns = {
      'TW': /^[A-Z]{1}[1289]{1}[0-9]{8}$/,           // 台灣: 10碼
      'CN': /^[0-9]{17}[0-9X]$/,                      // 中國: 18碼
      'HK': /^[A-Z]{1,2}[0-9]{6}\(?[0-9A]\)?$/,      // 香港: 7-9碼
      'MO': /^[157][0-9]{6}\([0-9]\)$/               // 澳門: 8-10碼
    };

    var pattern = patterns[country] || patterns['TW'];
    return this.optional(element) || pattern.test(value);
  },
  "身分證字號格式有誤!"
);
// LINE格式驗證
jQuery.validator.addMethod(
  "isLine",
  function (value, element) {
    var length = value.length;
    var isLine = /^[\.\_\-a-z0-9]+$/;
    return this.optional(element) || (length <= 20 && isLine.test(value));
  },
  "LINE格式有誤!"
);
// 信箱格式驗證
jQuery.validator.addMethod(
  "isEmail",
  function (value, element) {
    // var length = value.length;
    var isEmail =  /^[^\[\]\(\)\\<>:;,@.]+[^\[\]\(\)\\<>:;,@]*@[a-z0-9A-Z]+(([.]?[a-z0-9A-Z]+)*[-]*)*[.]([a-z0-9A-Z]+[-]*)+$/g;;
    return this.optional(element) || (isEmail.test(value));
  },
  "Email格式有誤!"
);
// 限中文
jQuery.validator.addMethod(
  "isChinese",
  function (value, element) {
    var isChinese = /^[\u4e00-\u9fd5\u3400-\u4db5]+$/;
    var length = value.length;
    return this.optional(element) || (length > 0 && isChinese.test(value));
  },
  "僅限中文"
);
// 帳號正規格式驗證
let accRegular = {"regular": new RegExp($('#accRegular').val()) , "regularMsg": $('#accRegularMsg').val()};
jQuery.validator.addMethod(
  "accRegular",
  function (value, element) {
    return this.optional(element) || accRegular.regular.test(value);
  },
  accRegular.regularMsg
);
// USDT格式驗證
var regular = /^/;
var bankCode;
$("#addusdtfrom select[name='addusdt_id']").change(function() {
  bankCode = $(this).find(":selected").data('bankcode');
  if (bankCode == 'ERC20') {
      regular = /^0x[0-9A-Za-z]*$/;
  } else if (bankCode == 'TRC20') {
      regular = /^T[0-9A-Za-z]*$/;
  }else {
      regular = /^/;
  }
});
jQuery.validator.addMethod(
  "isEtc",
  function(value, element) {
      var isEtc = regular;
      var length = value.length;
      return this.optional(element) || (length > 0 && isEtc.test(value));
  },
  "通道地址格式不符!"
);
// 電子錢包格式驗證：規則由 jsbank.tpl 錢包通道選項的 data-addrpattern / data-addrhint / data-addrupper 帶入
var ewlAddrPattern = "";
var ewlAddrHint = "";
$("#addewlfrom select[name=ewl_bank_id]").on("change", function () {
  var opt = $(this).find(":selected");
  var $addr = $("#addewlfrom input[name=ewl_account_no]");
  ewlAddrPattern = opt.data("addrpattern") || "";
  ewlAddrHint = opt.data("addrhint") || "";
  $addr.attr("placeholder", ewlAddrHint ? ewlAddrHint : "請輸入錢包地址");
  $addr.data("upper", opt.data("addrupper") == 1 ? 1 : 0);
  if ($addr.val() !== "") {
    // 先輸入地址、後選通道時，已輸入的值也要轉大寫再驗
    if ($addr.data("upper") == 1) {
      $addr.val($addr.val().toUpperCase());
    }
    $addr.valid();
  }
});
// 只認大寫的品牌，輸入當下就轉成大寫，所見即所送
$("#addewlfrom input[name=ewl_account_no]").on("input", function () {
  if ($(this).data("upper") == 1) {
    var pos = this.selectionStart;
    this.value = this.value.toUpperCase();
    this.setSelectionRange(pos, pos);
  }
});
jQuery.validator.addMethod("ewlAddr", function (value, element) {
  if (this.optional(element) || ewlAddrPattern === "") return true;
  try {
    return new RegExp(ewlAddrPattern).test(value);
  } catch (e) {
    return true;
  }
});
// 預設動作
$(".errWarning").hide();

// 特殊動作
// 登入的驗證圖片
$(".captcha").click(function () {
  var version = Math.random();
  $(".captcha").attr("src", `/captcha?_=${version}`);
});

// 更新登入 / 提款表單清空
$(".btnreset").on("click", function (e) {
  e.preventDefault();
  $("#upassresetform input, #pinpassresetform input").val("");
  $("#Amount, #bankPass, #amount").val("");
  $(".errWarning").hide();
});
var minin = "";
var maxin = "";
var mindep = $(this).find(":selected").data("minbonus");
var maxdep = $(this).find(":selected").data("maxbonus");
// 儲值使用  存款 / 優惠改變時
$(".deposit_bank_item").on("click", function () {
  minin = $(this).data("minin");
  maxin = $(this).data("maxin");
  chkdeposit(minin, maxin, mindep, maxdep)
});
$("#AccID").on("change", function () {
  minin = $(this).find(":selected").data("minin");
  maxin = $(this).find(":selected").data("maxin");
  chkdeposit(minin, maxin, mindep, maxdep)
});
$("#BonusID").on("change", function () {
  mindep = $(this).find(":selected").data("minbonus");
  maxdep = $(this).find(":selected").data("maxbonus");

  chkdeposit(minin, maxin, mindep, maxdep)
});

$('#amountBtn button').on('click', function() {
  let sum = $(this).val();
  let errorText = "";
  $("#Amount").val(sum)
  if (minin && maxin) {
    if(sum < minin) errorText = "最低存款金額";
    else if (sum > maxin) errorText = "最高存款金額";
    $("#Amount").rules("add", {
      min: Number(parseInt(minin)),
      max: Number(parseInt(maxin)),
      messages: {
        min: errorText + " " + parseInt(minin),
        max: errorText + " " + parseInt(maxin),
      },
    });
    $("#Amount").blur();
  }
});

$('input[name=cvsBtn]').on('click', function() {
  let cvs = $(this).val();
  $("input[name=bankdistrict]").val(cvs)
});

$('#amountBtnUsdt button').on('click', function() {
  let sum = $(this).val();
  let errorText = "最低存款金額";
  $("#AmountUsdt").val(sum)
  sum *= exchange
  $("#Amount").val(sum)
  if (minin && maxin) {
    if(sum < minin) errorText = "最低存款金額";
    else if (sum > maxin) errorText = "最高存款金額";
    $("#Amount").rules("add", {
      min: Number(parseInt(minin)),
      max: Number(parseInt(maxin)),
      messages: {
        min: errorText + " " + parseInt(minin),
        max: errorText + " " + parseInt(maxin),
      },
    });
    $("#Amount").blur();
  }
});

function chkdeposit(minin, maxin, mindep, maxdep) {
  minin = parseInt(minin);
  maxin = parseInt(maxin);
  mindep = parseInt(mindep);
  maxdep = parseInt(maxdep);
  var strmes1 = "";
  var strmes2 = "";
  if (!mindep && !maxdep && !minin && !maxin) {
    //若沒有選擇銀行上下限與優惠上下限時候
    finalMin = "";
    strmes1 = "選擇銀行帳戶或是優惠";
    strmes2 = "選擇銀行帳戶或是優惠";
    finalMax = "";
  } else if (!mindep && !maxdep && minin && maxin) {
    //若沒有選擇優惠 但有選擇銀行
    finalMin = minin;
    strmes1 = "最低存款金額";
    strmes2 = "最高存款金額";
    finalMax = maxin;
  } else if (mindep && maxdep && !minin && !maxin) {
    //若選擇優惠 但沒有選擇銀行
    finalMin = mindep;
    strmes1 = "最低優惠存款金額";
    strmes2 = "最高優惠存款金額";
    finalMax = maxdep;
  } else if (minin && maxin && mindep && maxdep) {
    //若銀行存款上下限 與 優惠存款上下限都存在時候
    //取最少存款
    if (minin <= mindep) {
      //若"銀行最少存款" 小於"優惠最小存款" 則取 "優惠最小存款"
      finalMin = mindep;
      strmes1 = "最低優惠存款金額";
    } else {
      finalMin = minin; //反之則取 "銀行最低存款"
      strmes1 = "最低存款金額";
    }
    //取最大存款
    if (maxin >= maxdep && maxdep != 0) {
      //若銀行最大存款大於優惠最大存款 則取優惠最大存款
      finalMax = maxdep;
      strmes2 = "最高優惠存款金額";
    } else {
      finalMax = maxin;
      strmes2 = "最高存款金額";
    }
  }
  $("#Amount").rules("add", {
    min: Number(finalMin),
    max: Number(finalMax),
    messages: {
      min: strmes1 + " " + finalMin,
      max: strmes2 + " " + finalMax,
    },
  });
  $("#Amount").focus();
  $("#Amount").blur();
}

// 更新錢包
$(".walrefresh").on("click", function (e) {
  e.preventDefault();
  header_wallet();
});

// 轉點選項處理
$("#transferfrom").change(function () {
  var value = this.value;
  $("#transferto option").each(function () {
    if ($(this).val() == value && $(this).val() != "") {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
});

$("#transferto").change(function () {
  var value = this.value;
  $("#transferfrom option").each(function () {
    if ($(this).val() == value && $(this).val() != "") {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
});

// 一鍵轉回主錢包
$("#ckxferbtn").on("click", function (e) {
  e.preventDefault();
  checkxfer();
});

// 傳送簡訊驗證碼
$("#sendActbtn").on("click", function (e) {
  e.preventDefault();
  // console.log("sendActivation BTN is click");
  var actphonenum = $("#activephone").val();
  if (!actphonenum) {
    swal("請輸入可接收簡訊的行動電話號碼", "", "error");
    $("#activephone")
      .css("background-color", "#ffcdd2")
      .css("border", "1px solid #e53935;")
      .focus();
  } else {
    $.ajax({
      url: "/registration_act.php",
      type: "POST",
      data: "a=sendActivation&mobile=" + $("input[name=phone]").val(),
      dataType: "json",
    })
      .fail(function (res) {
        console.log("sendactivation code error");
      })
      .done(function (res) {
        if (res.success == 0) {
          swal(res.msg, "", "success");
        } else {
          $("#activephone")
            .css("background-color", "#ffcdd2")
            .css("border", "1px solid #e53935;")
            .focus();
          swal(res.msg, "", "error");
        }
      });
  }
});

$("#loginform").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    lousername: {
      required: true,
      rangelength: [6, 20],
    },
    lopassword: {
      required: true,
      rangelength: [6, 20],
    },
    vcode: {
      required: true,
    },
  },
  messages: {
    lousername: {
      required: "請輸入帳號",
      rangelength: "僅限6到20個英文及數字。(AZ，az，0-9)",
    },
    lopassword: {
      required: "請輸入密碼",
      rangelength: "僅限6到20個英文及數字。(AZ，az，0-9)",
    },
    vcode: {
      required: "請輸入驗證碼",
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    login();
  },
});


$("#ssoform").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    lousername: {
      required: true,
      rangelength: [6, 20],
    },
    lopassword: {
      required: true,
      rangelength: [6, 20],
    },
    vcode: {
      required: true,
    },
  },
  messages: {
    lousername: {
      required: "請輸入帳號",
      rangelength: "僅限6到20個英文及數字。(AZ，az，0-9)",
    },
    lopassword: {
      required: "請輸入密碼",
      rangelength: "僅限6到20個英文及數字。(AZ，az，0-9)",
    },
    vcode: {
      required: "請輸入驗證碼",
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    ssologin();
  },
});

//20210427 註冊帳號手機立即驗證
function regCheck(ckfield1, ckcont1, element1){
  $.ajax({
      url: "/registration_act",
      type: "POST",
      data: {
        a: "ck" + ckfield1,
        ckcont: ckcont1,
      },
      dataType: "json",
  }).done(function (res) {
    if(res.success == -1){
      swal(res.msg, "", "error").then(function(){
        var elemm = $("#" + ckfield1 + "-error");
        elemm.empty().append(res.msg).css('color','#fb1900').show();
        $(element1).css('border', '2px solid red');

        if (ckfield1 == 'phone') $('#sendActbtn').prop("disabled", true);
      });
    } else {
        var elemm = $('#' + ckfield1 + '-error');
        elemm.empty();
        $(element1).css('border', '');

        if (ckfield1 == 'phone') $('#sendActbtn').prop("disabled", false);
    }
  });
}

function validPhone(e) {
  let phone = $(e).val()
  // 支援多國手機格式：台灣09開頭10碼、馬來西亞01開頭10-11碼、香港8碼、中國1開頭11碼
  if ((/^(09[0-9]{8}|01[0-9]{8,9}|[2-9][0-9]{7}|1[3-9][0-9]{9})$/).test(phone)) regCheck('phone', phone, e);
  else $('#sendActbtn').prop("disabled", true);
}

var registerform_sumbit = false;
// 註冊表單
$("#registerform").validate({
  onkeyup: false,
  onfocusout: function (element) {
    var ckfield = $(element).data("ckfield");
    if(ckfield && ckfield.length > 0){
      var ckcont = $(element).val();
      if(ckcont.length > 0){
          switch(ckfield){
          case 'account':
            if(accRegular.regular.test(ckcont)){
                regCheck(ckfield, ckcont, element);
            } else {
                $(element).valid();
            }
          break;
          default:
            $(element).valid();
          break;
          }
      } else {
        $(element).valid();
      }
    } else {
      $(element).valid();
    }
  },
  rules: {
    username: {
      required: true,
      isChinese: true,
    },
    account: {
      required: true,
      accRegular: true,
    },
    password: {
      required: true,
      rangelength: [6, 20],
    },
    chkpassword: {
      required: true,
      rangelength: [6, 20],
      equalTo: "#password",
    },
    regpbirth: {
      required: true,
    },
    email: {
      isEmail: true,
      required: true,
    },

    lineid: {
      required: function () {
          return ($('#sw_line').val() === 'Y' && $('#sw_line_required').val() === 'Y') ? true : false;
      },
      isLine: true,
    },
    phone: {
      required: true,
      rangelength: [8, 11],
      mobile: true,
    },
    Verificationcode: {
      required: true,
    },
    conditions: {
      required: true,
    },
    regulations: {
      required: true,
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  messages: {
    username: {
      required: "請輸入姓名",
      isChinese: "姓名僅限中文",
    },
    account: {
      required: "請輸入帳號",
      accRegular: accRegular.regularMsg,
    },
    password: {
      required: "請輸入密碼",
      rangelength: "僅限6到20個英文及數字。(AZ，az，0-9)",
    },
    chkpassword: {
      required: "請輸入確認密碼",
      rangelength: "僅限6到20個英文及數字。(AZ，az，0-9)",
      equalTo: "兩次密碼輸入不一致",
    },
    regpbirth: {
      required: "請輸入生日",
    },
    email: {
      required: "請輸入信箱",
      isEmail: "信箱格式有誤!"
    },
    lineid: {
      required: "請輸入LINE",
      isLine: "LINE格式有誤!"
    },
    phone: {
      required: "請輸入手機號碼",
      rangelength: "電話僅限8到11個數字",
      mobile: "請輸入有效的手機號碼",
    },
    Verificationcode: {
      required: "請輸入驗證碼",
    },
    conditions: {
      required: "請同意相關條款",
    },
  },
  submitHandler: function () {
    if (!registerform_sumbit) {
      registerform_sumbit = true;
      register()
    }
  },
});

// 更新登入密碼
$("#upassresetform").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    oldupass: {
      required: true,
      rangelength: [6, 20],
    },
    newupass: {
      required: true,
      rangelength: [6, 20],
    },
    cknewupass: {
      required: true,
      rangelength: [6, 20],
      equalTo: "#newupass",
    },
  },
  messages: {
    oldupass: {
      required: "請輸入當前密碼",
    },
    newupass: {
      required: "請輸入新密碼",
      rangelength: "僅限6到20個英文及數字。(AZ，az，0-9)",
    },
    cknewupass: {
      required: "請再次輸入密碼",
      rangelength: "僅限6到20個英文及數字。(AZ，az，0-9)",
      equalTo: "兩次密碼輸入不一致",
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    resetupass();
  },
});

// 更新安全密碼
$("#pinpassresetform").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    oldppass: {
      required: function() { return $("#hasBankPass").val() === "1"; },
      rangelength: [4, 10],
    },
    newppass: {
      required: true,
      rangelength: [4, 10],
    },
    cknewppass: {
      required: true,
      rangelength: [4, 10],
      equalTo: "#newppass",
    },
  },
  messages: {
    oldppass: {
      required: "請輸入當前安全密碼",
    },
    newppass: {
      required: "請輸入新安全密碼",
      rangelength: "僅限4到10個英文及數字。(AZ，az，0-9)",
    },
    cknewppass: {
      required: "請再次輸入新安全密碼",
      rangelength: "僅限4到10個英文及數字。(AZ，az，0-9)",
      equalTo: "兩次密碼輸入不一致",
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    resetppass();
  },
});

// 更新會員資料
$("#memberdataform").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    username: {
      isChinese: "會員姓名僅限中文",
    },
    uLine: {
      required: function () {
          return ($('#sw_line').val() === 'Y' && $('#sw_line_required').val() === 'Y') ? true : false;
      },
      isLine: true,
    },
    uEmail: {
      isEmail: true,
    },
  },
  messages: {
    username: {
      isChinese: "姓名僅限中文",
    },
    uLine: {
      required: "請輸入LINE",
      isLine: "LINE格式有誤!"
    },
    uEmail: {
      isEmail: "信箱格式有誤!"
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    updateProfile();
  },
});
// 發送站內信
$("#sendform").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    sendtitle: {
      required: true,
    },
    sendtext: {
      required: true,
    },
  },
  messages: {
    sendtitle: {
      required: "請輸入標題",
    },
    sendtext: {
      required: "請輸入訊息內容",
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    sendmessage();
  },
});

// 儲值表單
$("#depositform").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    AccID: {
      required: true,
    },
    Amount: {
      required: true,
      ruleCondition: true,
    },
  },
  messages: {
    AccID: {
      required: "請選擇存款類型",
    },
    Amount: {
      required: "請輸入儲值金額",
      ruleCondition: function () {
        return rulemsg;
      },
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    let branch = $("#AccID :selected").data('bankbranch');
    if(!branch){
      branch = $(".deposit_bank_item.active").data('bankbranch');
    }

    let ubid = $(`select[name='UBID']`).val();
    if (ubidreq) {
      if (branch == "CVS") {
        msg = "指定超商不能為空";
      } else {
        msg = "指定銀行不能為空";
      }
      if (ubid == 0) {
        swal(msg, "", "error");
        return false;
      }
    } else if (payset && !matchingpayset) {
      swal("請先綁定超商"+bankname, "", "error");
      return false;
    }
    if (branch == "CVS" && user_cvs < 1) {
        Swal.fire({
            title: '請綁定超商地區',
            type: 'info',
            html:'<div style="font-size:1.1rem">儲值前請先綁定超商地區</div>'
        }).then(function(){
            location.href = "./jsbank";
        });
    } else {
      submitPaygate();
    }
  },
});

// 提款表單
$("#withdrawform").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    bankPass: {
      required: true,
    },
    amount: {
      required: true,
      min: function () {
        return parseInt($("#miniWD").val());
      },
      max: function () {
        return parseInt($("#uUserBalance").val());
      },
      digits: true,
      withdrawLimitAmountRule: true,
    },
    verify: {
      required: true
    }
  },
  messages: {
    bankPass: {
      required: "請輸入安全密碼",
    },
    amount: {
      required: "請輸入提款金額",
      min: function () {
        return "最低提款金額： " + $("#miniWD").val();
      },
      max: function () {
        return "提款金額超過上限： " + $("#uUserBalance").val();
      },
      digits: "請輸入整數數字",
      withdrawLimitAmountRule: function () {
        return $("#AmountRuleErrorMessage").val();
      },
    },
    verify: {
      required: "請輸入驗證碼",
    }
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    confirmWithdrawal();
  },
});

//處理轉點
$("#transferform").validate({
  onkeyup: false,
  onfocusout: function (element) {
    var ckfield = $(element).data("ckfield");
    if(ckfield && ckfield.length > 0){
        var ckcont = $(element).val();
        if(ckcont.length > 0){
            switch(ckfield){
                case 'transferfrom':
                    let walletAmount = $('#transfrom_balance').val();
                    if($('#transferamount').val() > 0) {
                        if(isNaN(parseInt(walletAmount))) {
                            var elemm = $('#transferamount-error label');
                            elemm.empty().append(`最大額度: 0`).show();
                        } else if(parseInt(walletAmount) < $('#transferamount').val()) {
                            var elemm = $('#transferamount-error label');
                            elemm.empty().append(`最大額度: ${parseInt(walletAmount)}`).show();
                        } else {
                            var elemm = $('#transferamount-error label');
                            elemm.hide();
                        }
                    }
                break;
            }
        } else {
            $(element).valid();
        }
    } else {
        $(element).valid()
    }
  },
  rules: {
    transferfrom: {
      required: true,
    },
    transferto: {
      required: true,
    },
    transferamount: {
      required: true,
      min: 1,
      max: function () {
        return parseInt($("#transfrom_balance").val());
      },
      digits: true,
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  messages: {
    transferfrom: {
      required: "請選擇平臺",
    },
    transferto: {
      required: "請選擇平臺",
    },
    transferamount: {
      required: "請輸入金額",
      min: "最小額度: 1",
      max: function () {
        if (isNaN(parseInt($('#transfrom_balance').val()))) {
          return "最大額度: 0"
        } else if ($("#transfrom_balance").val()) {
          return "最大額度: " + parseInt($("#transfrom_balance").val());
        } else {
          return "請選擇轉點來源";
        }
      },
      digits: "請輸入整數數字",
    },
  },
  submitHandler: function () {
    saveTransfer();
  },
});

// 新增銀行表單
$("#addbankfrom").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    addbank_id: {
      required: true,
    },
    account_no: {
      required: true,
      rangelength: [10, 19],
    },
    account_name: {
      required: true,
    },
    branchcode: {
      required: true,
      digits: true,
      rangelength: [4, 4],
    },
    bankBranch: {
      isChinese: true,
    },
    ubank_pid: {
      required: true,
      passport: true,
    },
    regpbirth: {
      required: true,
    },
    pinpass: {
      required: true,
      rangelength: [4, 10],
    },
    ckpinpass: {
      required: true,
      rangelength: [4, 10],
      equalTo: "#pinpass",
    },
  },
  messages: {
    branchcode: {
      required: "請輸入分行代碼",
      digits:   "分行代碼僅限數字",
      rangelength:"僅限4個數字",
    },
    addbank_id: {
      required: "請輸入銀行名稱",
    },
    account_no: {
      required: "請輸入銀行帳號",
      rangelength: "僅限10到19個數字。(0-9)",
    },
    account_name: {
      required: "請輸入銀行戶名",
    },
    bankBranch: {
      isChinese: "分行名稱僅限中文",
    },
    ubank_pid: {
      required: "請輸入身份證字號",
      passport: "身分證字號格式有誤",
    },
    regpbirth: {
      required: "請輸入出生年月日",
    },
    pinpass: {
      required: "請輸入安全密碼",
      rangelength: "僅限4到10個英文及數字。(AZ，az，0-9)",
    },
    ckpinpass: {
      required: "請再次輸入安全密碼",
      rangelength: "僅限4到10個英文及數字。(AZ，az，0-9)",
      equalTo: "兩次密碼不一致",
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    updateBank();
  },
});

// 新增綁定信用卡
$("#addccdfrom").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    addbank_id: {
      required: true,
    },
    bankaccount_ccd: {
      required: true,
      rangelength: [10, 19],
    },
    account_name_ccd: {
      required: true,
    },
  },
  messages: {
    addbank_id: {
      required: "請輸入銀行名稱",
    },
    bankaccount_ccd: {
      required: "請輸入請輸入信用卡號",
      rangelength: "僅限15到19個數字。(0-9)",
    },
    account_name_ccd: {
      required: "請輸入持卡人",
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    updateCCD();
  },
});

// 新增超商綁定
$("#addcsvfrom").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    bankId: {
      required: true,
    },
    bankcounty: {
      required: true,
      isChinese: true,
    },
    bankdistrict: {
      required: true,
      isChinese: true,
    },
    branchcode: {
      required: true
    },
    branchbranch: {
      required: true,
    }
  },
  messages: {
    bankId: {
      required: "請選擇超商",
    },
    bankcounty: {
      required: "縣市不能為空",
      isChinese: "縣市僅限中文",
    },
    bankdistrict: {
      required: "鄉鎮市區不能為空",
      isChinese: "鄉鎮市區僅限中文",
    },
    branchcode: {
      required: "請輸入超商店號"
    },
    branchbranch: {
      required: "超商店名不能為空",
    }
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    addCVSArea();
  },
});

// 新增USDT表單
$("#addusdtfrom").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    addusdt_id: {
      required: true,
    },
    usdt_ubank_pid: {
      required: true,
      passport: true,
    },
    usdt_account_no: {
      required: true,
      rangelength: function() {
        if (bankCode == 'ERC20') {
            return [42, 42];
        } else {
            return [34, 34];
        }
      },
      isEtc: true,
    },
    usdt_account_name: {
      required: true,
      isChinese: ubank_accname == "N" ? false : true,
    },
    usdt_pinpass: {
      required: true,
      rangelength: [4, 10],
    },
    usdt_ckpinpass: {
      required: true,
      rangelength: [4, 10],
      equalTo: "#usdt_pinpass",
    },
  },
  messages: {
    addusdt_id: {
      required: "請選擇通道類型",
    },
    usdt_ubank_pid: {
      required: "請輸入身份證字號",
      passport: "身分證字號格式有誤",
    },
    usdt_account_no: {
      required: "請輸入通道地址",
      rangelength: function() {
        if (bankCode == 'ERC20') {
            return "僅限開頭為0x的42個英文或數字。";
        } else if (bankCode == 'TRC20') {
            return "僅限開頭為T的34個英文或數字。";
        }else{
            return "";
        }
      },
      isEtc: function() {
        if (bankCode == 'ERC20') {
            return "僅限開頭為0x的42個英文或數字。";
        } else if (bankCode == 'TRC20') {
            return "僅限開頭為T的34個英文或數字。";
        }else{
            return "請選擇通道類型";
        }
      },
    },
    usdt_account_name: {
      required: "請輸入通道戶名",
      isChinese: "通道戶名僅限中文",
    },
    usdt_pinpass: {
      required: "請輸入提領密碼",
      rangelength: "僅限4到10個英文及數字。(AZ，az，0-9)",
    },
    usdt_ckpinpass: {
      required: "請再次輸入提領密碼",
      rangelength: "僅限4到10個英文及數字。(AZ，az，0-9)",
      equalTo: "兩次密碼不一致",
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    updateUSDT();
  },
});

// 新增電子錢包表單
$("#addewlfrom").validate({
  onkeyup: false,
  onfocusout: function (element) {
    $(element).valid();
  },
  rules: {
    ewl_bank_id: {
      required: true,
    },
    ewl_account_no: {
      required: true,
      ewlAddr: true,
    },
    ewl_pinpass: {
      required: true,
      rangelength: [4, 10],
    },
    ewl_ckpinpass: {
      required: true,
      rangelength: [4, 10],
      equalTo: "#ewl_pinpass",
    },
  },
  messages: {
    ewl_bank_id: {
      required: "請選擇錢包通道",
    },
    ewl_account_no: {
      required: "請輸入錢包地址",
      ewlAddr: function () {
        return ewlAddrHint ? "錢包地址格式不符，" + ewlAddrHint : "錢包地址格式不符";
      },
    },
    ewl_pinpass: {
      required: "請輸入安全密碼",
      rangelength: "僅限4到10個英文及數字。(AZ，az，0-9)",
    },
    ewl_ckpinpass: {
      required: "請再次輸入安全密碼",
      rangelength: "僅限4到10個英文及數字。(AZ，az，0-9)",
      equalTo: "兩次密碼不一致",
    },
  },
  errorPlacement: function (error, element) {
    var elemm = $("#" + element[0].name + "-error");
    elemm.empty();
    error.appendTo(elemm);
    elemm.show();
  },
  submitHandler: function () {
    updateEWL();
  },
});

function login() {
  var errormsg = "";
  var Account = $('input[name="lousername"]').val().replace(/\s/g, "");
  var Password = $('input[name="lopassword"]').val().replace(/\s/g, "");
  var VCode = $('input[name="vcode"]').val().replace(/\s/g, "");
  $("button.submit").prop("disabled", true);

  $.ajax({
    url: "/login",
    type: "POST",
    data: {
      a: "login",
      Account: Account,
      Password: Password,
      VCode: VCode,
      Device: (typeof use_device !== 'undefined' ? use_device : ""),
      _csrf_token: $('input[name="_csrf_token"]').val()
    },
    dataType: "json",
  })
    .fail(function (res) {
      $("button.submit").prop("disabled", false);
      swal("出現問題，請稍後再試!", "", "error");
    })
    .done(function (res) {
      $("button.submit").prop("disabled", false);
      if (res.success == 0) {
        swal("登入成功", "", "success").then(function () {
          sessionStorage.setItem("Ann", true);
          sessionStorage.setItem("inbox", true);
          location.href = "./index";
        })
      } else if (res.success == -4) {
        swal(res.msg, "", "warning").then(function () {
          location.href = "./index?verify";
        });
      } else {
        if(res.msg == '驗證碼錯誤') {
          $(".captcha").click();
          $('input[name="vcode"]').val('').focus()
          swal(res.msg, "", "error")
        }
        else if(res.success == -2) {
          $(".captcha").click();
          $('input[name="lousername"]').val('').focus()
          $('input[name="lopassword"]').val('')
          $('input[name="vcode"]').val('')
          swal(res.msg, "", "error")
        }
        else {
          swal(res.msg, "", "error").then(function () {
            $(".captcha").click();
          })
        }
      }
    });
}

function ssologin() {
  var errormsg = "";
  var Account = $('input[name="lousername"]').val().replace(/\s/g, "");
  var Password = $('input[name="lopassword"]').val().replace(/\s/g, "");
  var VCode = $('input[name="vcode"]').val().replace(/\s/g, "");
  $(".btnbx button").prop("disabled", true);

  $.ajax({
    url: "/sso",
    type: "POST",
    data: {
      a: "login",
      Account: Account,
      Password: Password,
      VCode: VCode,
      Device: (typeof use_device !== 'undefined' ? use_device : ""),
      callback: $('input[name="callback"]').val(),
      '_csrf_token': $('input[name="_csrf_token"]').val()
      //Murmur: murmur
    },
    dataType: "json",
  })
    .fail(function (res) {
      $(".btnbx button").prop("disabled", false);
      swal("出現問題，請稍後再試!", "", "error");
    })
    .done(function (res) {
      $(".btnbx button").prop("disabled", false);
      if (res.success == 0) {
        swal("登入成功!", "請關閉視窗回原系統操作", "success").then(function () {
          location.href = $('input[name="redirect"]').val();
        })
      } else if (res.success == -4) {
        swal(res.msg, "", "warning").then(function () {
          location.href = "./index?verify";
        });
      } else {
        if(res.msg == '驗證碼錯誤') {
          $(".captcha").click();
          $('input[name="vcode"]').val('').focus()
          swal(res.msg, "", "error")
        }
        else if(res.success == -2) {
          $(".captcha").click();
          $('input[name="lousername"]').val('').focus()
          $('input[name="lopassword"]').val('')
          $('input[name="vcode"]').val('')
          swal(res.msg, "", "error")
        }
        else {
          swal(res.msg, "", "error").then(function () {
            $(".captcha").click();
          })
        }
      }
    });
}
//修改會員資料
function updateProfile() {
  var uGender = $('input[name="uGender"]').val();
  var uBirthday = $('input[name="uBirthday"]').val();
  var uEmail = $('input[name="uEmail"]').val();
  var uLine = $('input[name="uLine"]').val();
  var uAddr = $('input[name="uAddr"]').val();
  let _data = {
    a: "updateProfile",
    uGender: uGender,
    uBirthday: uBirthday,
    uEmail: uEmail,
    uLine: uLine,
    uAddr: uAddr,
  }

  let isName = $("#sw_username").val();
  if (isName == "Y") {
    let uName = $('input[name="username"]').val();
    _data.uName = uName
  }

  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: _data,
    dataType: "json",
  })
  .fail(function (res) {
    //btn_load.stop();
    swal("出現問題，請稍後再試!", "", "error");
  })
  .done(function (res) {
    if (res.success == 0) {
      swal(res.msg, "", "success").then(function () {
        location.reload();
      });
    } else {
      switch (res.success) {
        case -99999:
        case -9999:
          if (logintype) {
            logintype = false;
            swal(res.msg, "", "error").then(function () {
              location.href = "/logout";
            });
          }
          break;
        default:
          swal(res.msg, "", "error");
          break;
      }
    }
  });
}
//更新登入與安全密碼
function resetupass() {
  var Oldpassword = $("input[name=oldupass]").val();
  var Newpassword = $("input[name=newupass]").val();
  var Newchkpassword = $("input[name=cknewupass]").val();
  var _data =
    "a=updatePass&Oldpassword=" +
    Oldpassword +
    "&Newpassword=" +
    Newpassword +
    "&Newchkpassword=" +
    Newchkpassword;
  $("#upassreset button:submit").attr("disabled", true);

  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: _data,
    dataType: "json",
  })
    .fail(function (res) {
      swal("更新失败", "", "error");
    })
    .done(function (res) {
      if (res.success == 0) {
        swal(res.msg, "", "success").then(function () {
          location.href = "/logout";
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
      }
      $("#upassresetform input").val("");
      $(".errWarning").hide();
    });
}

function resetppass() {
  var OldPin = $("input[name=oldppass]").val() || "";
  var NewPin = $("input[name=newppass]").val();
  var ChkPin = $("input[name=cknewppass]").val();
  var _data =
    "a=updateBankPass&NewPin=" +
    NewPin +
    "&ChkPin=" +
    ChkPin +
    "&OldPin=" +
    OldPin;
  $("#pinpassreset button:submit").attr("disabled", true);

  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: _data,
    dataType: "json",
  })
    .fail(function (res) {
      swal("更新失败", "", "error");
    })
    .done(function (res) {
      if (res.success == 0) {
        swal(res.msg, "", "success").then(function () {
          location.reload();
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "./logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        $("#pinpassresetform input").val("");
        $(".errWarning").hide();
      }
    });
}

// 儲值
function submitPaygate() {
  let warning = "";
  let bankBranch = $('#AccID').find(':selected').data('bankbranch');
  if (bankBranch == "CVS") warning = "已收到您的提單，至超商繳費後請拍照提供存補單列印服務繳費單、繳款證明收據，並傳給客服做核對，謝謝";
  if (bankBranch == "ATM") warning = "已收到您的提單，若是ATM轉帳請留存轉帳繳款明細、網路銀行轉帳請留存轉帳成功明細截圖。為避免爭議，將以此收據及照片作為追朔查詢收據，謝謝";

  var _data = $("#depositform").serialize();
  $("#depositform button:submit").attr("disabled", true);
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: _data,
    dataType: "json",
  })
    .fail(function (res) {
      swal("提交失敗", "", "error");
      $("#depositform button:submit").attr("disabled", false);
      return false;
    })
    .done(function (res) {
      $("#depositform button:submit").attr("disabled", false);
      if (res.success == 0) {
        swal(res.msg, warning, "success").then(function () {
          // location.reload();
          window.open(
            "/thirdparty_pay.php?tp=" +
            res.data.ThirdParty +
            "&pid=" +
            res.data.TradeID
          );
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "./logout";
              });
            }
            break;
          case -2:
            swal(res.msg, "", "error").then(function () {
              location.reload();
            });
            break;
          case -3:
            swal("投資金額低於優惠最小存款金額 " + res.msg, "", "error").then(
              function () {
                $("#PaygateAmount-error")
                  .empty()
                  .append("最低優惠存款金額 " + res.msg)
                  .show();
              }
            );
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
      }
    });
}

// 提款前確認視窗
function confirmWithdrawal() {
  swal({
    title: "需使用上筆存款帳號申請",
    html: '<div style="font-size:1.5rem">核對無誤後請點擊確認</div>',
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確認",
    cancelButtonText: "取消",
    reverseButtons: true,
  }).then(function (result) {
    if (result.value) {
      withdrawal();
    }
  });
}

// 處理提款
function withdrawal() {
  var _data = $("#withdrawform").serialize();
  $("#withdrawform button:submit").attr("disabled", true);
  var TAmount = $("#utAmount").val();
  var TBAmount = $("#utBetAmount").val();
  var uResetDate = $("#uResetDate").val();
  var uWithdrawCT = $("#uWithdrawCT").val();
  betcompare = $("#betcompare").val();
  withdraw_limit = $("#withdraw_limit").val();

  if (withdraw_limit === "Y") {
    if (uWithdrawCT > 0) {
      var ctext1 = "尚有未處理完成之提款單，請聯繫客服!";
      swal(ctext1, "", "error");
      return false;
    }
  }

  if (betcompare === "Y") {
    if (parseInt(TBAmount) < parseInt(TAmount)) {
      var ctext =
        "從 " +
        uResetDate +
        "<br>累積打碼量: " +
        TBAmount +
        "<br>所需打碼量: " +
        TAmount;
      swal("未達打碼量", ctext, "error");
      return false;
    }
  } else if (betcompare === "N") {
    console.log("N" + TAmount);
  }

  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: _data,
    dataType: "json",
  })
    .fail(function (res) {
      swal("提交失敗", "", "error");
      $("#withdrawform button:submit").attr("disabled", false);
    })
    .done(function (res) {
      $("#withdrawform button:submit").attr("disabled", false);
      if (res.success == 0) {
        swal(res.msg, "", "success").then(function () {
          location.reload();
        });
      } else {
        switch (res.success) {
          case -2:
            swal(res.msg, "", "error").then(function () {
              location.reload();
            });
            break;
          case -3:
            swal(res.msg, "", "error");
            break;
          case -11:
            swal(res.msg, "", "error").then(function () {
              location.reload();
            });
            break;
          case -103:
            swal(res.msg, "", "error");
            $("#verify").val("").focus();
            break;
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            let errorBank = res.msg;
            swal(errorBank.replace('提款密碼', '安全密碼'), "", "error");
            break;
        }
      }
    });
}

// 站內信  須依照畫面修正
var currentInboxTypeId = '';
function InboxList(page) {
  let last2month = new Date(today.getTime() - 62 * 24 * 60 * 60 * 1000);
  last2month = format_time(last2month);
  let startData2 = last2month + " 00:00:00";

  var _page = page ? page : 1;
  var reqData = `a=getInbox&t=list&p=${_page}&sd=${startData2}&ed=${endData}`;
  if (currentInboxTypeId !== '') {
    reqData += `&typeId=${currentInboxTypeId}`;
  }
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: reqData,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      swal("資料查詢失敗", "", "error")
    })
    .done(function (res) {
      if (res.success == 0) {
        var content = "";

        content = createNotifyRecord(res);
        $("#notify-content").html(content);

        if (res.data.r.length > 0) {
          content = createModalRecord(res);
          $("#inbox-modal-content").html(content);
          $("#inbox").fadeIn();
        }

        if ($("#accordion").length > 0) {
          content = createContactusRecord(res);
          $("#accordion").html(content);
          setContactusRecordListener();
        }

        if ($("#paginationu").length > 0) {
          let _pagination = createRecordPagination(_page, res.data.p.TotalPage, "InboxList");
          $("#paginationu").empty().html(_pagination);
        }

      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
      }
    });
}

function createModalRecord(res) {
  let content = "";
  let count = 0;

  for (i = 0; i < res.data.r.length; i++) {
      let checkInboxIsNotRead = {
        1: res.data.r[i].ToStatus == 0,
        2: res.data.r[i].ReplyStatus == 1 && res.data.r[i].ToStatus == 0
      }

      if (checkInboxIsNotRead[res.data.r[i].FromTo]) {
        count +=1;
        content += `
          <div class="item">
              <div class="item-inner">
                  <div class="thumbnail">
                      <a class="image" href="#">
                          <img class="absolute ll lt" src="${$(".notify-item-img").attr('src')}" loading="lazy">
                      </a>
                  </div>
                  <div class="info">
                      <h3 class="title">
                          <a class="block line-clamp-2" href="javascript:;">${res.data.r[i].BoxTitle}</a>
                      </h3>
                      <div class="description line-clamp-2">${res.data.r[i].BoxContent}</div>
                      <span class="date">${res.data.r[i].CreateDate}</span>
                  </div>
              </div>
          </div>`;
      }

  }
  $(".ibacc").html(count)

  return content
}

function createNotifyRecord(res) {
  var content = "";
  let empty = `
    <div class="item">
        <div class="item-inner">
            <div class="thumbnail"></div>
            <div class="info">
                <h3 class="title">
                    <a class="block line-clamp-2" href="javascript:;">暫無信息</a>
                </h3>
                <div class="description line-clamp-2"></div>
                <span class="date"></span>
            </div>
        </div>
    </div>`;

  for (i = 0; i < res.data.r.length; i++) {
    let checkInboxIsNotRead = {
      1: res.data.r[i].ToStatus == 0,
      2: res.data.r[i].ReplyStatus == 1 && res.data.r[i].ToStatus == 0
    }

    var NoticeTagStatus = checkInboxIsNotRead[res.data.r[i].FromTo] ? "block" : "none";
    content += `
      <div class="item">
          <div class="item-inner">
              <i class="fas fa-circle" style="position: absolute; font-size: 9px; top: 3px; left: 3px; color: #DA193B; display: ${NoticeTagStatus}" id="ibr_${res.data.r[i].BoxID}"></i>
              <div class="thumbnail">
                  <a class="image" href="${res.data.r[i].BoxID ? '/contactus?boxid=' + res.data.r[i].BoxID : 'javascript:;'}">
                      <img class="absolute ll lt" src="${$(".notify-item-img").attr('src')}" loading="lazy">
                  </a>
              </div>
              <div class="info">
                  <h3 class="title">
                      <a class="block line-clamp-2" href="${res.data.r[i].BoxID ? '/contactus?boxid=' + res.data.r[i].BoxID : 'javascript:;'}">${res.data.r[i].BoxTitle}</a>
                  </h3>
                  <div class="description line-clamp-2">${res.data.r[i].BoxContent}</div>
                  <span class="date">${res.data.r[i].CreateDate}</span>
              </div>
          </div>
      </div>`;
  }

  return content || empty;
}


function createContactusRecord(res) {
  var content = "";
  let empty = `
    <div class="item mb-md">
      <div class="info">
          <div class="info-inner">
              <strong class="title mb-xs" data-boxid="">
                  <span data-tag=""></span>暫無信息
              </strong>
              <div class="date"></div>
              <div class="content"></div>
          </div>
      </div>
    </div>`;


  for (i = 0; i < res.data.r.length; i++) {
    let checkInboxIsNotRead = {
      1: res.data.r[i].ToStatus == 0,
      2: res.data.r[i].ReplyStatus == 1 && res.data.r[i].ToStatus == 0
    }

    var NoticeTagStatus = checkInboxIsNotRead[res.data.r[i].FromTo] ? "block" : "none";
    var replyContentStatus = (res.data.r[i].ReplyContent) ? "block" : "none";

    let title = res.data.r[i].BoxTitle.split(":");
    content += `
      <div class="item mb-md">
        <i class="fas fa-circle" style="position: absolute; font-size: 9px; top: 3px; left: 3px; color: #DA193B; display: ${NoticeTagStatus}" id="ibr_${res.data.r[i].BoxID}"></i>
        <div class="info">
            <div class="info-inner">
                <strong class="title mb-xs" data-boxid="${res.data.r[i].BoxID}">
                    <span data-tag="">${title[1] ? title[0] : "站內信"}</span> ${title[1]||title[0]}
                    <i class="fas fa-plus"></i>
                </strong>
                <div class="date">${res.data.r[i].CreateDate}</div>
                <div class="content">${res.data.r[i].BoxContent}</div>
                <div style="display: ${replyContentStatus}">
                  <span data-tag="管理員回覆">管理員回覆</span>
                </div>
                <div class="reply">${res.data.r[i].ReplyContent}</div>
            </div>
        </div>
      </div>`;
  }

  return content || empty;
}

function setContactusRecordListener() {
  $('#accordion .title').each(function () {
    $(this).on('click', function () {
      var boxid = $(this).data('boxid');
      var readdata = 'a=getInbox&t=udstatus' + '&boxid=' + boxid;
      $.ajax({
        url: "../../member_act.php",
        type: "POST",
        data: readdata,
        dataType: "json",
      })
      .fail(function (res) {
        swal(res.msg, "", "error");
      })
      .done(function (res) {
        if (res.success == 0) {
          getibacc();
          if (res.msg == 'Success') {
            $('#ibr_' + boxid).hide();
          }
        } else {
          switch (res.success) {
            case -99999:
            case -9999:
              if (logintype) {
                logintype = false;
                swal(res.msg, "", "error").then(function () {
                  location.href = "/logout";
                });
              }
              break;
            default:
              swal(res.msg, "", "error");
              break;
          }
        }
      })
    });
  });
}


//處理站內信數量顯示
function getibacc() {
  var today = new Date();
  let last2month = new Date(today.getTime() - 62 * 24 * 60 * 60 * 1000);
  last2month = format_time(last2month);
  let startData2 = last2month + " 00:00:00";
  var endData = format_time(today) + " 23:59:59";
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: "a=getInbox&t=getcount" + "&sd=" + startData2 + "&ed=" + endData,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      $('#header li.top-navigation-notify > a').empty();
    })
    .done(function (res) {
      if (res.success == 0) {
        if (res.data.acc) {
          let tag = `<span class="badge cursor-pointer bounce" data-count="${res.data.acc}">${res.data.acc}</span>`
          $('#header li.top-navigation-notify > a').html(tag);
        } else {
          $('#header li.top-navigation-notify > a').empty();

        }
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
      }
    });
}

function sendmessage() {
  var ibTitle = `${$('#c_message_select :selected').text()} : ${$(".sendtitle").val()}`;
  var ibContent = $(".input_text").val();
  var _data =
    "a=getInbox&t=add&ibTitle=" +
    ibTitle +
    "&ibContent=" +
    ibContent;
  $.ajax({
    url: '../../member_act.php',
    type: 'POST',
    data: _data,
    dataType: 'json'
  }).fail(function (res) {
    // console.log(res);
    swal('出現問題，請稍後再試! 或請使用 Line客服!', "", 'error');
  }).done(function (res) {
    if (res.success == 0) {
      if (res.data && res.data.success) {
        switch (res.data.success) {
          case 19:
            swal('發送成功', "", 'info').then(function () {
              location.href = "./contactus";
            });
            break;
          case -19:
            swal('出現問題，請稍後再試! 或請使用 Line客服!', "", 'error').then(function () {
              $('#sendform .sendtitle').val('');
              $('#sendform .input_text').val('');
            });
            break;
        }
      }
    } else {
      switch (res.success) {
        case -99999:
        case -9999:
          if (logintype) {
            logintype = false;
            swal(res.msg, "", "error").then(function () {
              location.href = "/logout";
            });
          }
          break;
        default:
          swal(res.msg, "", "error");
          break;
      }
    }

  });
}

function createRecordPagination(currentPage, totalPages, func) {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  let prevpage = currentPage == 1 ? currentPage : parseInt(currentPage)-1;
  let nextpage = currentPage == totalPages ? totalPages : parseInt(currentPage)+1;

  let _pagination = `
    <li class="page-item" style="cursor: pointer;">
      <a class="page-link" onclick="$(this).closest('ul').find('select').val(1).change()"><i class="fas fa-angle-double-left"></i></a>
    </li>
    <li class="page-item" style="cursor: pointer;">
      <a class="page-link" onclick="$(this).closest('ul').find('select').val(${prevpage}).change()"><i class="fas fa-angle-left"></i></a>
    </li>
    <select class="select pages" onchange="${func}(value)">${pages.map(page => `<option value="${page}" ${currentPage == page ? "selected" : ""}>${page}</option>`).join('')}</select>
    <li class="page-item" style="cursor: pointer;">
      <a class="page-link" onclick="$(this).closest('ul').find('select').val(${nextpage}).change()"><i class="fas fa-angle-right"></i></a>
    </li>
    <li class="page-item" style="cursor: pointer;">
      <a class="page-link" onclick="$(this).closest('ul').find('select').val(${totalPages}).change()"><i class="fas fa-angle-double-right"></i></a>
    </li>`;

  return _pagination;
}

// 儲值紀錄
function his_deposit(page) {
  // $('.pagination').empty();
  $("#loader-bg").fadeIn();
  $("#depositc_tbl").empty().append('<tr><td colspan="5">查詢中...</td></tr>');
  var _page = page ? page : 1;
  var cnodata = '<tr><td colspan="5">查無資料</td></tr>';
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: {
      a: "getRecord",
      t: "deposit",
      p: _page,
      range: "30d",
    },
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      swal("資料查詢失敗", "", "error").then(function () {
        $("#depositc_tbl").empty().append(cnodata);
      });
    })
    .done(function (res) {
      $("#loader-bg").fadeOut(1000);
      if (res.success == 0) {
        var contentc = (contentm = "");

        for (i = 0; i < res.data.r.length; i++) {
          var d_status = '';
          if (res.data.r[i].TicketStatus == '成功') d_status = '<span style="color:#2196F3">成功</span>'
          else if (res.data.r[i].TicketStatus == '失敗') d_status = '<span style="color:#F44336">失敗</span>'
          else d_status = '<span>' + res.data.r[i].TicketStatus + '</span>'
          let remark = res.data.r[i].Reply ? `<span style="cursor: help"><span class="rnote" data-note="${html_encode(res.data.r[i].Reply)}">詳情</span></span>` : "&nbsp;";
          contentc += `
            <tr>
              <td data-title="日期">${res.data.r[i].CreateDate}</td>
              <td data-title="單號">${res.data.r[i].TicketID}</td>
              <td data-title="金額">${res.data.r[i].Amount}</td>
              <td data-title="狀態">${d_status}</td>
              <td data-title="備註">${remark}</td>
            </tr>`;
        }

        if (res.data.p.TotalCount !== 0) {
          let _pagination = createRecordPagination(_page, res.data.p.TotalPage, "his_deposit");

          $("#deposit_pagi").empty().html(_pagination);
          $("#depositc_tbl").html(contentc);
        } else {
          $("#depositc_tbl").empty().append(cnodata);
        }

        handlerPaginationClick();

        $(".rnote").on("click", function () {
          var rnote = $(this).data("note");
          swal("備註", html_encode(rnote));
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "./logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        $("#depositc_tbl").empty().append(cnodata);
      }
    });
}

// 提款紀錄
function his_withdraw(page) {
  // $('.pagination').empty();
  $("#loader-bg").fadeIn();
  $("#withdrawc_tbl").empty().append('<tr><td colspan="5">查詢中...</td></tr>');
  var _page = page ? page : 1;
  var cnodata = '<tr><td colspan="5">查無資料</td></tr>';
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data:{
      a: "getRecord",
      t: "withdrawal",
      p: _page,
      range: "30d"
    },
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      swal("資料查詢失敗", "", "error").then(function () {
        $("#withdrawc_tbl").empty().append(cnodata);
      });
    })
    .done(function (res) {
      $("#loader-bg").fadeOut(1000);
      if (res.success == 0) {
        var contentc = (contentm = "");

        for (i = 0; i < res.data.r.length; i++) {
          var w_status = '';
          if (res.data.r[i].TicketStatus == '成功') w_status = '<span style="color:#2196F3">成功</span>'
          else if (res.data.r[i].TicketStatus == '失敗') w_status = '<span style="color:#F44336">失敗</span>'
          else if (res.data.r[i].TicketStatus == '新票') w_status = '<span style="color:#f19b1b">新票</span>'
          else w_status = '<span>' + res.data.r[i].TicketStatus + '</span>';

          let remark = res.data.r[i].Reply ? `<span style="cursor: help"><span class="rnote" data-note="${html_encode(res.data.r[i].Reply)}">詳情</span></span>` : "&nbsp;";
          contentc += `
            <tr>
              <td data-title="日期">${res.data.r[i].CreateDate}</td>
              <td data-title="單號">${res.data.r[i].TicketID}</td>
              <td data-title="金額">${res.data.r[i].Amount}</td>
              <td data-title="狀態">${w_status}</td>
              <td data-title="備註">${remark}</td>
            </tr>`;
        }

        if (res.data.p.TotalCount !== 0) {
          let _pagination = createRecordPagination(_page, res.data.p.TotalPage, "his_withdraw");

          $("#withdraw_pagi").empty().html(_pagination);
          $("#withdrawc_tbl").html(contentc);
        } else {
          $("#withdrawc_tbl").empty().append(cnodata);
        }

        handlerPaginationClick();

        $(".rnote").on("click", function () {
          var rnote = $(this).data("note");
          swal("備註", html_encode(rnote));
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "./logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        $("#withdrawc_tbl").empty().append(cnodata);
      }
    });
}

// 轉點紀錄
function his_transfer(page) {
  // $('.pagination').empty();
  $("#loader-bg").fadeIn();
  $("#transferc_tbl").empty().append('<tr><td colspan="6">查詢中...</td></tr>');
  var _page = page ? page : 1;
  var cnodata = '<tr><td colspan="6">查無資料</td></tr>';
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data:
      "a=getRecord&t=transfer" +
      "&p=" +
      _page +
      "&sd=" +
      startData +
      "&ed=" +
      endData,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      swal("資料查詢失敗", "", "error").then(function () {
        $("#transferc_tbl").empty().append(cnodata);
      });
    })
    .done(function (res) {
      $("#loader-bg").fadeOut(1000);
      if (res.success == 0) {
        var contentc = (contentm = "");

        for (i = 0; i < res.data.r.length; i++) {
          var t_status = '';
          if (res.data.r[i].TicketStatus == '成功') t_status = '<span style="color:#2196F3">成功</span>'
          else t_status = '<span style="color:#F44336">' + res.data.r[i].TicketStatus + '</span>'

          contentc += `
            <tr>
              <td data-title="日期">${res.data.r[i].CreateDate}</td>
              <td data-title="單號">${res.data.r[i].TicketID}</td>
              <td data-title="從">${res.data.r[i].FromHall}</td>
              <td data-title="至">${res.data.r[i].ToHall}</td>
              <td data-title="金額">${res.data.r[i].Amount}</td>
              <td data-title="狀態">${t_status}</td>
            </tr>
          `;
        }

        if (res.data.p.TotalCount !== 0) {
          let _pagination = createRecordPagination(_page, res.data.p.TotalPage, "his_transfer");

          $("#transfer_pagi").empty().html(_pagination);
          $("#transferc_tbl").html(contentc);
        } else {
          $("#transferc_tbl").empty().append(cnodata);
        }

        handlerPaginationClick();

        $(".rnote").on("click", function () {
          var rnote = $(this).data("note");
          swal("備註", html_encode(rnote));
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "./logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        $("#transferc_tbl").empty().append(cnodata);
      }
    });
}

// 返水紀錄
function his_rebate(page) {
  // $('.pagination').empty();
  $("#loader-bg").fadeIn();
  $("#rebatec_tbl").empty().append('<tr><td colspan="4">查詢中...</td></tr>');
  var _page = page ? page : 1;
  var cnodata = '<tr><td colspan="4">查無資料</td></tr>';
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: {
      a: "getRecord",
      t: "rebate",
      p: _page,
      sd: startData,
      ed: endData,
      RebateType: $("input[name='RebateType']:checked").val()
    },
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      swal("資料查詢失敗", "", "error").then(function () {
        $("#rebatec_tbl").empty().append(cnodata);
      });
    })
    .done(function (res) {
      $("#loader-bg").fadeOut(1000);
      if (res.success == 0) {
        var contentc = (contentm = "");

        for (i = 0; i < res.data.r.length; i++) {
          contentc += `
          <tr>
            <td data-title="日期">${res.data.r[i].GCDate}</td>
            <td data-title="單號"></td>
            <td data-title="館別"><div class="rnote" data-note="${res.data.r[i].GCDate}">詳情</div></td>
            <td data-title="金額">${res.data.r[i].Rebate}</td>
          </tr>`;
          for (j = 0; j < res.data.r[i].rdet.length; j++) {
            contentc += `
            <tr style="display:none; background: #feeed6;" class="${res.data.r[i].GCDate}">
              <td data-title="日期">${res.data.r[i].rdet[j].UpdateDate}</td>
              <td data-title="單號">${res.data.r[i].rdet[j].TicketID}</td>
              <td data-title="館別">${res.data.r[i].rdet[j].HallName}(${res.data.r[i].rdet[j].TypeName})</td>
              <td data-title="金額">${res.data.r[i].rdet[j].Rebate}</td>
            </tr>`;
          }
        }

        if (res.data.p.TotalCount !== 0) {
          let _pagination = createRecordPagination(_page, res.data.p.TotalPage, "his_rebate");

          $("#rebate_pagi").empty().html(_pagination);
          $("#rebatec_tbl").html(contentc);
        } else {
          $("#rebatec_tbl").empty().append(cnodata);
        }

        handlerPaginationClick();

        $(".rnote").on("click", function () {
          var rnote = $(this).data("note");
          // console.log(rnote)
          $(`.${rnote}`).toggle()
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "./logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        $("#rebatec_tbl").empty().append(cnodata);
      }
    });
}

//派彩紀錄
function his_lottery(page) {
  // $('.pagination').empty();
  let l_startData = $('#search-daterangepicker').data('daterangepicker').startDate.format('YYYY-MM-DD HH:mm:ss')
  let l_endData = $('#search-daterangepicker').data('daterangepicker').endDate.format('YYYY-MM-DD HH:mm:ss')
  // 收集勾選的館別 HallID
  var _ghidarr = '';
  var activeHalls = $('#ghidarr .hall-tag.active');
  if (activeHalls.length > 0 && activeHalls.first().data('id') != -1) {
    var ids = [];
    activeHalls.each(function () { ids.push($(this).data('id')); });
    _ghidarr = ids.join(',');
  }
  $("#loader-bg").fadeIn();
  $("#lotteryc_tbl").empty().append('<tr><td colspan="7">查詢中...</td></tr>');
  $("#total_tbl").empty().append(`
      <tr>
          <td colspan="3" style="color: #e6e6e6; background: #1a7958;">小計</td>
          <td data-title="投注" colspan="1" style="text-align: right; ">-</td>
          <td data-title="有效" colspan="1" style="text-align: right; ">-</td>
          <td data-title="輸贏" colspan="2" style="text-align: right; ">-</td>
      </tr>
      <tr>
          <td colspan="3" style="color: #e6e6e6; background: #1a7958;">總計</td>
          <td data-title="投注" colspan="1" style="text-align: right; ">-</td>
          <td data-title="有效" colspan="1" style="text-align: right; ">-</td>
          <td data-title="輸贏" colspan="2" style="text-align: right; ">-</td>
      </tr>
  `);
  var cnodata = '<tr><td colspan="7" class="text-center">查無資料</td></tr>';
  var _page = page ? page : 1;
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data:
      "a=getRecord&t=lottery" +
      "&p=" +
      _page +
      "&ghidarr=" +
      _ghidarr +
      "&sd=" +
      l_startData +
      "&ed=" +
      l_endData,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      swal("資料查詢失敗", "", "error").then(function () {
        $("#lotteryc_tbl").empty().append(cnodata);
      });
    })
    .done(function (res) {
      $("#loader-bg").fadeOut(1000);
      if (res.success == 0) {
        var contentc = '';
        let totalc = '';
        let TotalAmount = '';
        let TotalBetAmount = '';
        let TotalWinLoss = '';
        let STotalColor = 'color:#2196F3';
        let TotalColor = 'color:#2196F3';
        for (i = 0; i < res.data.r.length; i++) {
          var winloss =
            '<span style="color:#F44336">' + res.data.r[i].WinLoss + "</span>";
          if (res.data.r[i].WinLoss > 0) {
            winloss =
              '<span style="color:#2196F3">' + res.data.r[i].WinLoss + "</span>";
          } else if (res.data.r[i].WinLoss == 0) {
            winloss = '<span>' + res.data.r[i].WinLoss + "</span>";
          }
          contentc += `
            <tr>
              <td data-title="日期">${res.data.r[i].WagerDate}</td>
              <td data-title="單號">${res.data.r[i].WagerID}</td>
              <td data-title="館別">${res.data.r[i].HallName}  ${res.data.r[i].TypeName}</td>
              <td data-title="投注" style="text-align: right;">${res.data.r[i].Amount}</td>
              <td data-title="有效" style="text-align: right;">${res.data.r[i].BetAmount}</td>
              <td data-title="輸贏" style="text-align: right;">${winloss}</td>
            </tr>`;
        }
        if (res.data.c) {
          TotalAmount = res.data.c[0].CAmount;
          TotalBetAmount = res.data.c[0].CBetAmount;
          TotalWinLoss = res.data.c[0].CWinLoss.toFixed(2)
          if (parseInt(TotalWinLoss) < 0) TotalColor = 'color:#F44336';
        } else {
          TotalAmount = 0;
          TotalBetAmount = 0;
          TotalWinLoss = 0
        }
        if (parseInt(res.data.s.SWinLoss) < 0) STotalColor = 'color:#F44336';
        totalc += `
            <tr>
                <td colspan="3" style="color: #e6e6e6; background: #1a7958;">小計</td>
                <td data-title="投注" colspan="1" style="text-align: right; ">${res.data.s.SAmount}</td>
                <td data-title="有效" colspan="1" style="text-align: right; ">${res.data.s.SBetAmount}</td>
                <td data-title="輸贏" colspan="2" style="text-align: right; ${STotalColor}">${res.data.s.SWinLoss.toFixed(2)}</td>
            </tr>
            <tr>
                <td colspan="3" style="color: #e6e6e6; background: #1a7958;">總計</td>
                <td data-title="投注" colspan="1" style="text-align: right; ">${TotalAmount}</td>
                <td data-title="有效" colspan="1" style="text-align: right; ">${TotalBetAmount}</td>
                <td data-title="輸贏" colspan="2" style="text-align: right; ${TotalColor}">${TotalWinLoss}</td>
            </tr>
        `

        if (res.data.p.TotalCount !== 0) {
          $(".noRecord").hide();
          let _pagination = createRecordPagination(_page, res.data.p.TotalPage, "his_lottery");

          $("#lottery-pagi").empty().html(_pagination);
          $("#lotteryc_tbl").empty().append(contentc);
          $("#total_tbl").empty().append(totalc);
        } else {
          $("#lotteryc_tbl").empty().append(cnodata);
        }

        handlerPaginationClick();
        $(".rnote").on("click", function () {
          var rnote = $(this).data("note");
          swal("備註", html_encode(rnote));
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        $("#lotteryc_tbl").empty().append(cnodata);
      }
    });
}

// 優惠紀錄
function his_bonus(page) {
  // $('.pagination').empty();
  let l_startData = $('#search-daterangepicker').data('daterangepicker').startDate.format('YYYY-MM-DD HH:mm:ss')
  let l_endData = $('#search-daterangepicker').data('daterangepicker').endDate.format('YYYY-MM-DD HH:mm:ss')
  $("#loader-bg").fadeIn();
  $("#bonusc_tbl").empty().append('<tr><td colspan="5">查詢中...</td></tr>');
  var _page = page ? page : 1;
  var cnodata = '<tr><td colspan="5">查無資料</td></tr>';
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data:
      "a=getRecord&t=bonus" +
      "&p=" +
      _page +
      "&sd=" +
      l_startData +
      "&ed=" +
      l_endData,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      swal("資料查詢失敗", "", "error").then(function () {
        $("#bonusc_tbl").empty().append(cnodata);
      });
    })
    .done(function (res) {
      $("#loader-bg").fadeOut(1000);
      if (res.success == 0) {
        var contentc = (contentm = "");

        let statusMap = {"已領取": "#2196F3", "已取消": "#F44336", "申請中": "#f19b1b"};
        for (i = 0; i < res.data.r.length; i++) {
          let TicketStatus = statusMap[res.data.r[i].TicketStatus] ? `<span style="color: ${statusMap[res.data.r[i].TicketStatus]};">${res.data.r[i].TicketStatus}</span>` : `<span>${res.data.r[i].TicketStatus}</span>`;

          contentc += `
            <tr>
              <td data-title="日期">${res.data.r[i].CreateDate}</td>
              <td data-title="單號">${res.data.r[i].BTicketID}</td>
              <td data-title="名稱">${res.data.r[i].BonusName}</td>
              <td data-title="金額">${res.data.r[i].BonusAmount}</td>
              <td data-title="狀態">${TicketStatus}</td>
            </tr>`;
        }

        if (res.data.p.TotalCount !== 0) {
          let _pagination = createRecordPagination(_page, res.data.p.TotalPage, "his_bonus");

          $("#bonus_pagi").empty().html(_pagination);
          $("#bonusc_tbl").html(contentc);
        } else {
          $("#bonusc_tbl").empty().append(cnodata);
        }
        handlerPaginationClick();

      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "./logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        $("#bonusc_tbl").empty().append(cnodata);
      }
    });
}

// 序號兌獎紀錄
function his_coupon(page) {
  $("#loader-bg").fadeIn();
  $("#couponc_tbl").empty().append('<tr><td colspan="4">查詢中...</td></tr>');
  var _page = page ? page : 1;
  var cnodata = '<tr><td colspan="4">查無資料</td></tr>';
  $.ajax({
    url: "/serial_redeem_act",
    type: "POST",
    data: "a=getHistory&page=" + _page,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      swal("資料查詢失敗", "", "error").then(function () {
        $("#couponc_tbl").empty().append(cnodata);
      });
    })
    .done(function (res) {
      $("#loader-bg").fadeOut(1000);
      if (res.success == 0) {
        var contentc = "";
        for (i = 0; i < res.data.list.length; i++) {
          let RedeemDate = moment.unix(res.data.list[i].RedeemDate).utcOffset(8).format("YYYY-MM-DD HH:mm:ss");
          contentc += `
            <tr>
              <td data-title="日期">${RedeemDate}</td>
              <td data-title="兌獎序號">${res.data.list[i].SerialCode}</td>
              <td data-title="禮金">${Number(res.data.list[i].Amount).toLocaleString()}</td>
              <td data-title="狀態"><span style="color: #4caf50;">成功</span></td>
            </tr>`;
        }

        if (res.data.total != 0) {
          let _pagination = createRecordPagination(_page, res.data.totalPages, "his_coupon");
          $("#coupon_pagi").empty().html(_pagination);
          $("#couponc_tbl").html(contentc);
        } else {
          $("#couponc_tbl").empty().append(cnodata);
        }
        handlerPaginationClick();
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "./logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        $("#couponc_tbl").empty().append(cnodata);
      }
    });
}

// 更新錢包
function header_wallet(type) {
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: "a=getHall",
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
    })
    .done(function (res) {
      if (res.success == 0) {
        gamedata = res.data.h;
        loop_balance();
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "./logout";
              });
            }
            break;
        }
      }
    });
}

function loop_balance() {
  $("#total_balance")
    .empty()
    .append(
      '<div class="loader_purse"><div class="lds-loader_purse"></div></div>'
    );
  $(".balance_count")
    .empty()
    .append(
      '<div class="loader_purse"><div class="lds-loader_purse"></div></div>'
    );
  $("#transferfrom").html(
    $("<option></option>").attr("value", "").text("請選擇")
  );
  $("#transferto").html(
    $("<option></option>").attr("value", "").text("請選擇")
  );
  for (var i = 0; i < gamedata.length; i++) {
    if (gamedata[i].GameAccount == null && gamedata[i].HallCode != "Master") {
      $("." + gamedata[i].HallCode + "_Balance").empty();
      $("." + gamedata[i].HallCode + "_Balance").text("未開通");
      $("#transferfrom").append(
        $("<option></option>")
          .attr("value", gamedata[i].HallCode)
          .text(gamedata[i].HallName + " (未開通)")
      );
      $("#transferto").append(
        $("<option></option>")
          .attr("value", gamedata[i].HallCode)
          .text(gamedata[i].HallName + " (未開通)")
      );
      $("select option[value=" + gamedata[i].HallCode + "]").attr(
        "disabled",
        "disabled"
      );
    } else if (gamedata[i].HallStatus != 1) {
      $("." + gamedata[i].HallCode + "_Balance").empty();
      $("." + gamedata[i].HallCode + "_Balance").text("維護中");
      $("#transferfrom").append(
        $("<option></option>")
          .attr("value", gamedata[i].HallCode)
          .text(gamedata[i].HallName + " (維護中)")
      );
      $("#transferto").append(
        $("<option></option>")
          .attr("value", gamedata[i].HallCode)
          .text(gamedata[i].HallName + " (維護中)")
      );
      $("select option[value=" + gamedata[i].HallCode + "]").attr(
        "disabled",
        "disabled"
      );
    } else if (gamedata[i].StateCode == "limited") {
      $("#transferfrom").append(
        $("<option></option>")
          .attr("value", gamedata[i].HallCode)
          .text(gamedata[i].HallName + " (讀取中)")
      );
      $("#transferto").append(
        $("<option></option>")
          .attr("value", gamedata[i].HallCode)
          .text(gamedata[i].HallName + " (" + gamedata[i].StateLabel + ")")
      );
      $("#transferto option[value=" + gamedata[i].HallCode + "]")
        .attr("disabled", "disabled")
        .addClass("perm-block");
      $("#transferfrom option[value=" + gamedata[i].HallCode + "]").attr(
        "disabled",
        "disabled"
      );
      pro_balance(gamedata[i].HallCode, gamedata[i].HallName);
    } else {
      $("#transferfrom").append(
        $("<option></option>")
          .attr("value", gamedata[i].HallCode)
          .text(gamedata[i].HallName + " (讀取中)")
      );
      $("#transferto").append(
        $("<option></option>")
          .attr("value", gamedata[i].HallCode)
          .text(gamedata[i].HallName + " (讀取中)")
      );
      $("select option[value=" + gamedata[i].HallCode + "]").attr(
        "disabled",
        "disabled"
      );
      pro_balance(gamedata[i].HallCode, gamedata[i].HallName);
    }
  }
}

function pro_balance(wallet, HallName) {
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: "a=getBalance&h=" + wallet,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      $("." + wallet + "_Balance")
        .empty()
        .text("失敗");
      $("select option[value=" + wallet + "]").attr("disabled", "disabled");
    })
    .done(function (res) {
      $("." + wallet + "_Balance").empty();
      if (res.success == 0) {
        if (res.data) {
          var balance = res.data.Balance ? res.data.Balance : "失敗";
        } else {
          var balance = "失敗";
          //$("select option[value=" + wallet + "]").attr('disabled','disabled');
        }
        $("select option[value=" + wallet + "]").not(".perm-block")
          .text(HallName)
          .removeAttr("disabled");
        $("." + wallet + "_Balance").text(balance);
        transfer_balance(wallet, balance);
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "./logout";
              });
            }
            break;
          case -2:
            $("." + wallet + "_Balance")
              .empty()
              .text("維護中");
            $("#transferform select option[value=" + wallet + "]").attr(
              "disabled",
              "disabled"
            );
            $("#transferform select option[value=" + wallet + "]").text(
              HallName + " (維護中)"
            );
            break;
          case -1:
            $("." + wallet + "_Balance")
              .empty()
              .text("失敗");
            $("#transferform select option[value=" + wallet + "]").attr(
              "disabled",
              "disabled"
            );
            $("#transferform select option[value=" + wallet + "]").text(
              HallName + " (失敗)"
            );
            break;
          default:
            $("." + wallet + "_Balance")
              .empty()
              .text("失敗");
            $("#transferform select option[value=" + wallet + "]").attr(
              "disabled",
              "disabled"
            );
            $("#transferform select option[value=" + wallet + "]").text(
              HallName + " (失敗)"
            );
            break;
        }
      }
    });
}

function transfer_balance(wallet, balance) {
  var Balancelist = $(".balance_count");
  var rtotal = 0;
  Balancelist = Object.values(Balancelist).map((item) =>
    Number(item.innerHTML)
  );
  Balancelist = Balancelist.filter((val) => !isNaN(val));
  for (i = 0; i < Balancelist.length; i++) {
    rtotal += Balancelist[i] * 1000000;
  }
  rtotal = (rtotal / 1000000).toFixed(2);
  $("#total_balance, #master_amount").text(rtotal);

  if (XferAllAlert && wallet == "Master" && XferAllError) {
    XferAllAlert = false;
    swal("轉點完成", "", "success");
  }
}

// 轉點
function saveTransfer() {
  var _form = $("#transferfrom").val();
  var _to = $("#transferto").val();
  var transferamount = $("#transferamount").val();

  if (_form == _to) {
    swal("請選擇不同館別");
    return false;
  }

  $("#transferform button:submit").attr("disabled", "disabled");

  if (_form != "Master" && _to != "Master") {
    $.ajax({
      url: "../../member_act.php",
      type: "POST",
      data:
        "a=saveTransfer&from=" + _form + "&to=Master&amount=" + transferamount,
      dataType: "json",
    })
      .fail(function (res) {
        console.log("fail");
        $("#transferform button:submit").removeAttr("disabled");
      })
      .done(function (res) {
        if (res.success == 0) {
          $.ajax({
            url: "../../member_act.php",
            type: "POST",
            data:
              "a=saveTransfer&from=Master&to=" +
              _to +
              "&amount=" +
              transferamount,
            dataType: "json",
          })
            .fail(function (res) {
              swal("轉點失敗" + "\n 點數已轉至主錢包", "", "error").then(
                function () {
                  header_wallet();
                }
              );
              $("#transferform button:submit").removeAttr("disabled");
            })
            .done(function (res) {
              $("#transferform button:submit").removeAttr("disabled");
              if (res.success == 0) {
                swal(res.msg, "", "success").then(function () {
                  header_wallet();
                  xfer_form_rest();
                });
              } else {
                switch (res.success) {
                  case -99999:
                  case -9999:
                    if (logintype) {
                      logintype = false;
                      swal(res.msg, "", "error").then(function () {
                        location.href = "./logout";
                      });
                    }
                    break;
                  default:
                    swal(res.msg + "\n 點數已轉至主錢包", "", "error").then(
                      function () {
                        header_wallet();
                      }
                    );
                    break;
                }
              }
            });
        } else {
          $("#transferform button:submit").removeAttr("disabled");
          switch (res.success) {
            case -99999:
            case -9999:
              if (logintype) {
                logintype = false;
                swal(res.msg, "", "error").then(function () {
                  location.href = "./logout";
                });
              }
              break;
            case -2:
              swal(res.msg, "", "error");
              header_wallet();
              break;
            default:
              swal(res.msg, "", "error");
              break;
          }
        }
      });
  } else {
    var _data =
      "a=saveTransfer&from=" +
      _form +
      "&to=" +
      _to +
      "&amount=" +
      transferamount;
    $.ajax({
      url: "../../member_act.php",
      type: "POST",
      data: _data,
      dataType: "json",
    })
      .fail(function (res) {
        swal("轉點失敗", "", "error");
        $("#transferform button:submit").removeAttr("disabled");
      })
      .done(function (res) {
        $("#transferform button:submit").removeAttr("disabled");
        if (res.success == 0) {
          swal(res.msg, "", "success");
          header_wallet();
          xfer_form_rest();
        } else {
          switch (res.success) {
            case -99999:
            case -9999:
              if (logintype) {
                logintype = false;
                swal(res.msg, "", "error").then(function () {
                  location.href = "./logout";
                });
              }
              break;
            case -2:
              swal(res.msg, "", "error").then(function () {
                header_wallet();
              });
              break;
            default:
              swal(res.msg, "", "error");
              break;
          }
        }
      });
  }
}

// 一鍵轉入主錢包
function checkxfer() {
  swal({
    title: "確定全部轉移到主錢包？",
    text: "",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true,
  }).then(function (result) {
    if (result.value) {
      oneClickTransfer();
    }
  });
}

function oneClickTransfer() {
  $("#ckxferbtn").prop("disabled", true);
  $("#total_balance").empty().append('<div class="loader_purse"><div class="lds-loader_purse"></div></div>');
  $(".balance_count").empty().append('<div class="loader_purse"><div class="lds-loader_purse"></div></div>');
  $.ajax({
    url: '../../member_act.php',
    type: 'POST',
    data: 'a=oneclicktransfer',
    dataType: 'json'
  }).fail(function (res) {
    swal("出現問題，請稍後再試!", "", "error");
    $("#ckxferbtn").prop("disabled", false);
  }).done(function (res) {
    $("#ckxferbtn").prop("disabled", false);
    if(res.success == 0) {
      if(res.transfer_count === 'N'){
        swal('其他館別無餘額可轉點至主錢包','','warning');
      } else {
        swal('轉點成功','','success');
      }
      header_wallet();
    } else {
      switch (res.success) {
        case -99999:
        case -9999:
          swal({
            text: res.msg,
            type: 'error',
          }).then(function () {
            location.href = '/logout';
          })
          break;
        case -2:
          swal(res.msg, '', 'error').then(function(){
            header_wallet();
          });
          break;
        default:
          swal(res.msg, '', 'error');
          header_wallet();
          break;
      }
    }
  })
}

// 設定銀行
function updateBank() {
  var accName = $("input[name=account_name]").val();
  var bankId = $("input[name=addbank_id]").val();
  if (bankId=='') {
    swal('請選擇銀行', "輸入後請點選銀行", "error");
    return false; 
  }
  var bankAcc = $("input[name=account_no]").val();
  if ($('#accpid').val() === 'Y') {
    var accPid = $('input[name="ubank_pid"]').val();
    var pidCountry = $('select[name="pid_country"]').val() || 'TW';
  }
  if ($('#accpbirth').val() === 'Y') {
    var accPbirth = $('input[name="regpbirth"]').val();
  }
  var bankProvince = "";
  var bankCounty = "";
  var branchcode = $("input[name='branchcode']").val();
  var bankBranch = $("input[name='bankBranch']").val();
  if ((checkBranch !='' || checkBranchcode !='') && (checkBranch != bankBranch || checkBranchcode != branchcode)) {
    swal('分行名稱與分行代碼不相符', "請重新確認分行名稱與分行代碼", "error");
    return false; 
  }
  if ($('#uBankCF').val() == 0) {
    var wdpin = $("input[name=pinpass]").val();
    var chkwdpin = $("input[name=ckpinpass]").val();
  } else {
    var wdpin = '';
    var chkwdpin = '';
  }

  var _data =
    "a=updateBank2&bankId=" +
    bankId +
    "&accName=" +
    accName +
    "&accPid=" +
    accPid +
    "&pid_country=" +
    pidCountry +
    "&accPbirth=" +
    accPbirth +
    "&bankAcc=" +
    bankAcc +
    "&BankProvince=" +
    bankProvince +
    "&BankCounty=" +
    bankCounty +
    "&BranchCode=" +
    branchcode +
    "&BankBranch=" +
    bankBranch +
    "&NewPin=" +
    wdpin +
    "&ChkPin=" +
    chkwdpin;

  $("#addbankfrom button:submit").attr("disabled", "disabled");
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: _data,
    dataType: "json"
  })
  .fail(function (res) {
    swal("新增失敗", "", "error");
    $("#addbankfrom button:submit").removeAttr("disabled");
  })
  .done(function (res) {
    $("#addbankfrom button:submit").removeAttr("disabled");
    if (res.success == 0) {
      swal("請至聯繫客服上傳銀行資料", "", "success").then(function () {
        location.href = lineUrl;
      });
    } else {
      switch (res.success) {
        case -99999:
        case -9999:
          if (logintype) {
            logintype = false;
            swal(res.msg, "", "error").then(function () {
              location.href = "./logout";
            });
          }
          break;
        default:
          let errorBank = res.msg;
          swal(errorBank.replace('提款密碼', '安全密碼'), "", "error");
          break;
      }
    }
  });
}

// 超商綁定
function addCVSArea() {
  $("input[name=CVSArea\\[BankCounty\\]]").val($("#addcsvfrom input[name=bankcounty]").val());
  $("input[name=CVSArea\\[BankDistrict\\]]").val($("#addcsvfrom input[name=bankdistrict]").val());
  $("input[name=CVSArea\\[BranchCode\\]]").val($("#addcsvfrom input[name=branchcode]").val());
  $("input[name=CVSArea\\[BankBranch\\]]").val($("#addcsvfrom input[name=bankbranch]").val());
  var _data  = $("#addcsvfrom").serialize();

$("#addcsvfrom button:submit").attr("disabled", "disabled");
$.ajax({
  url: "../../member_act.php",
  type: "POST",
  data: _data,
  dataType: "json",
})
  .fail(function (res) {
    swal("綁定失敗", "", "error");
    $("#addcsvfrom button:submit").removeAttr("disabled");
  })
  .done(function (res) {
    $("#addcsvfrom button:submit").removeAttr("disabled");
    if (res.success == 0) {
      swal("【請聯繫客服】", "", "success").then(function () {
        location.href = "./jsbank";
      });
    } else {
      switch (res.success) {
        case 0:
          swal(res.msg, "", "success");
        case -99999:
        case -9999:
          if (logintype) {
            logintype = false;
            swal(res.msg, "", "error").then(function () {
              location.href = "./logout";
            });
          }
          break;
        default:
          swal(res.msg, "", "error");
          break;
      }
    }
  });

}
function updateCCD() {
  var account_name_ccd = $("input[name=account_name_ccd]").val();
  var bankaccount_ccd = $("input[name=bankaccount_ccd]").val();
  var bankId = $("input[name=addbank_id]").val();
  if (bankId=='') {
    swal('請選擇銀行', "輸入後請點選銀行", "error");
    return false; 
  }

  var _data =
  "a=bindPaymentCCD&BankID=" +
  bankId +
  "&AccountName=" +
  account_name_ccd +
  "&AccountNumber=" +
  bankaccount_ccd;

  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: _data,
    dataType: "json",
  })
  .fail(function (res) {
    swal("新增失敗", "", "error");
    $("#addusdtfrom button:submit").removeAttr("disabled");
  })
  .done(function (res) {
    $("#addusdtfrom button:submit").removeAttr("disabled");
    if (res.success == 0) {
      swal(res.msg, "", "success").then(function () {
        location.href = "./jsbank";
      });
    } else {
      switch (res.success) {
        case -99999:
        case -9999:
          if (logintype) {
            logintype = false;
            swal(res.msg, "", "error").then(function () {
              location.href = "./logout";
            });
          }
          break;
        default:
          let errorBank = res.msg;
          swal(errorBank, "", "error");
          break;
      }
    }
  });
};

// 設定USDT
function updateUSDT() {
  var accName = $("input[name=usdt_account_name]").val();
  var bankId = $("select[name=addusdt_id]").val();
  var bankAcc = $("input[name=usdt_account_no]").val();

  if ($('#accpid').val() === 'Y') {
    var accPid = $('input[name="usdt_ubank_pid"]').val();
    var pidCountry = $('select[name="usdt_pid_country"]').val() || 'TW';
  }
  if ($('#accpbirth').val() === 'Y') {
    var accPbirth = $('input[name="usdt_regpbirth"]').val();
  }
  var bankProvince = "";
  var bankCounty = "";
  if ($('#uBankCF2').val() == 0) {
    var wdpin = $("input[name=usdt_pinpass]").val();
    var chkwdpin = $("input[name=usdt_ckpinpass]").val();
  } else {
    var wdpin = '';
    var chkwdpin = '';
  }
  var _data =
    "a=addUsdtChnnel&bankId=" +
    bankId +
    "&accName=" +
    accName +
    "&accPid=" +
    accPid +
    "&pid_country=" +
    pidCountry +
    "&accPbirth=" +
    accPbirth +
    "&bankAcc=" +
    bankAcc +
    "&BankProvince=" +
    bankProvince +
    "&BankCounty=" +
    bankCounty +
    "&NewPin=" +
    wdpin +
    "&ChkPin=" +
    chkwdpin;

  $("#addusdtfrom button:submit").attr("disabled", "disabled");
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: _data,
    dataType: "json",
  })
    .fail(function (res) {
      swal("新增失敗", "", "error");
      $("#addusdtfrom button:submit").removeAttr("disabled");
    })
    .done(function (res) {
      $("#addusdtfrom button:submit").removeAttr("disabled");
      if (res.success == 0) {
        swal(res.msg, "", "success").then(function () {
          location.href = "./jsbank";
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "./logout";
              });
            }
            break;
          default:
            let errorBank = res.msg;
            swal(errorBank.replace('提款密碼', '提領密碼'), "", "error");
            break;
        }
      }
    });
}

// 設定電子錢包
function updateEWL() {
  var $btn = $("#addewlfrom button:submit");
  $btn.attr("disabled", "disabled");
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    dataType: "json",
    data: {
      a: "bindPaymentEWL",
      BankID: $("#addewlfrom select[name=ewl_bank_id]").val(),
      AccountNumber: $("#addewlfrom input[name=ewl_account_no]").val(),
      NewPin: $("#ewl_pinpass").val() || "",
      ChkPin: $("#ewl_ckpinpass").val() || "",
    },
  })
    .fail(function () {
      swal("新增失敗", "", "error");
      $btn.removeAttr("disabled");
    })
    .done(function (res) {
      $btn.removeAttr("disabled");
      if (res.success == 0) {
        swal(res.msg, "", "success").then(function () {
          location.href = "./jsbank";
        });
      } else if (res.success == -99999 || res.success == -9999) {
        if (logintype) {
          logintype = false;
          swal(res.msg, "", "error").then(function () {
            location.href = "./logout";
          });
        }
      } else {
        swal(String(res.msg).replace("提款密碼", "安全密碼"), "", "error");
      }
    });
}

// 註冊
function register() {
  var Name = $('input[name="username"]').val();
  var Account = $('input[name="account"]').val();
  var Password = $('input[name="password"]').val();
  var Chkpassword = $('input[name="chkpassword"]').val();
  var Phone = $('input[name="phone"]').val();
  var Email = $('input[name="email"]').val();
  var agcode = $('input[name="agcode"]').val();
  if ($('#sw_line').val() === 'Y') {
    var Line = $('input[name="lineid"]').val();
  }
  if ($('#sw_Verificationcode').val() === 'Y') {
    var Verificationcode = $('input[name="Verificationcode"]').val();
  }
  if (regneedpbrth && regneedpbrth === "Y") {
    var regpbirth = $('input[name="regpbirth"]').val();
    var today = new Date().getTime();
    var todayts = Math.floor(today / 1000);
    var pbirth = new Date(regpbirth).getTime();
    var pbirthts = Math.floor(pbirth / 1000);
    if (todayts - pbirthts < 568080000) {
      swal("【年齡限制：本公司只接受年齡已滿18歲的註冊用戶。】", "", "error");
      return false;
    }
  }
  $.ajax({
    url: "/registration_act",
    type: "POST",
    data: {
      a: "add",
      Name: Name,
      Account: Account,
      Password: Password,
      ChkPassword: Chkpassword,
      regpbirth: regpbirth,
      Phone: Phone,
      Email: Email,
      Line: Line,
      // Verificationcode: Verificationcode,
      agcode: agcode,
      Device: (typeof use_device !== 'undefined' ? use_device : ""),
    },
    dataType: "json",
  })
    .fail(function (res) {
      registerform_sumbit = false;
      swal("出現問題，請稍後再試!", "", "error");
    })
    .done(function (res) {
      registerform_sumbit = false;
      console.log(res.success)
      if (res.success == 0) {
        swal(res.msg, "", "success").then(function () {
          location.href = "./index?verify";
        });
      } else {
        swal(res.msg, "", "error");
      }
    });
}

// // 遊戲列表 要修正列表形式
// function gameData(gametype, themename) {
//   var url = "/tpl/" + themename + "/js/" + gametype + ".json";
//   $.getJSON(url, function (res) {
//     gameslist = res;
//     changeCategory(gametype, themename);
//   });
// }

// function changeCategory(gametype, themename) {
//   $(".games_Options").html("");
//   for (var i = 0; i < gameslist.length; i++) {
//     var content = '<div class="col-4 col-lg-2 Slot_games">';
//     content += '<div class="gameOne">';
//     content +=
//       '<img src="/tpl/' +
//       themename +
//       "/images/" +
//       gametype +
//       "/" +
//       gameslist[i].GameImg +
//       '.png">';
//     if (demoplay === "T") {
//       content +=
//         '<button name="' +
//         gameslist[i].GameID +
//         '" class="gamelink"><h2>立即遊戲</h2></button>';
//       content +=
//         '<button name="' +
//         gameslist[i].GameID +
//         '" class="gamedemo"><h2>立即試玩</h2></button>';
//     } else {
//       content +=
//         '<button name="' +
//         gameslist[i].GameID +
//         '" class="gamelink" style="width: 100%;"><h2>立即遊戲</h2></button>';
//     }
//     content += "</div>";
//     content += "</div>";
//     $(".games_Options").append(content);
//   }
// }
$(document).ready(function () {
  $('.Refresh_Balance').click(function () {
    $(".Master_Balance").text('查詢中...');
    $.ajax({
      url: "../../member_act.php",
      type: "POST",
      data: "a=getBalance&h=Master",
      dataType: "json",
    })
      .fail(function (res) {
        console.log("fail");
      })
      .done(function (res) {
        // console.log(res);
        if (res.success == 0) {
          $(".Master_Balance").text(res.data.Balance);
        } else {
          switch (res.success) {
            case -99999:
            case -9999:
              if (logintype) {
                logintype = false;
                swal(res.msg, "", "error").then(function () {
                  location.href = "/logout";
                });
              }
              break;
            default:
              swal(res.msg, "", "error");
              break;
          }
        }
      });
  });
});
// 處理電腦版轉點 modal 變數
var gameg = "", gametitle = "", gamecode = "";

// 遊戲轉點modal顯示
function showtrmodal(gametitle3, hallcode, gamecode = null) {
  $("#ndtrtogame, #notrtogame").data('gamecode', gamecode)
  $("#whallName").text(gametitle3);
  $("#trhall").val(hallcode);
  $(".fromhall_block .hall").text("主錢包");
  $("#fromhall").val("Master");

  if (WalletType == 1) {
    swal({
      title: "處理中",
      text: `正在進入遊戲(${gametitle3})`,
      onOpen: () => swal.showLoading(),
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    $.ajax({
      url: "../../member_act",
      type: "POST",
      data: "a=confirmPlayer&h=" + hallcode,
      dataType: "json",
    }).fail(function () {
      swal("系統忙碌，請稍後再試", "", "error");
    }).done(function (res) {
      if (res.success != 0) {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        return;
      }
      allInGame();
    });
    return;
  }

  $("#modal-transfer").fadeIn();
  $(".game_error").show();
  $(".game_error_btn").hide();
  $("#tringtext").hide();
  $('#modal-transfer').removeClass("modal-loading")
  $("#transmodal .game_error a").prop("disabled", true).css({ "cursor": "not-allowed", "opacity": "0.7" });
  $("#tramount").val('');
  $('.dropdown-toggle, .dropdown-menu').removeClass('show');

  $("#Master-Balance").text("...載入中...")
  play_wallet("Master");
  play_wallet(hallcode);
}
// 20201006 電腦版遊戲前獲得錢包餘額
function play_wallet(wallet) {
  if (wallet == "Master") {
    gettbalance(wallet);
  } else {
    $("#Wallet-Balance").text("...載入中...");
    $.ajax({
      url: "../../member_act.php",
      type: "POST",
      data: "a=confirmPlayer&h=" + wallet,
      dataType: "json",
    })
      .fail(function (res) {
        console.log("fail");
        $("#Wallet-Balance").text("失敗");
      })
      .done(function (res) {
        if (res.success == 0) {
          gettbalance(wallet);
        } else {
          $("#transmodal .game_error a").prop("disabled", true).css("cursor", "not-allowed");
          switch (res.success) {
            case -99999:
            case -9999:
              if (logintype) {
                logintype = false;
                swal(res.msg, "", "error").then(function () {
                  location.href = "/logout";
                });
              }
              break;
            case -2:
              $("#Wallet-Balance").text("遊戲維護中");
              $(".game_error").hide();
              $(".game_error_btn").show();
              break;
            case -3:
              $("#Wallet-Balance").text("遊戲尚未開放");
              $(".game_error").hide();
              $(".game_error_btn").show();
              break;
            default:
              $("#Wallet-Balance").text("失敗");
              $(".game_error").hide();
              $(".game_error_btn").show();
              break;
          }
        }
      });
  }
}
// 20201007 建立遊戲帳號
function gettbalance(wallet) {
  var textpos = "";
  if (wallet == "Master") {
    textpos = "Master";
  } else {
    textpos = "Wallet";
  }
  return $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: "a=getBalance&h=" + wallet,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      $("#" + textpos + "-Balance").text("失敗");
      $(".game_error").hide();
      $(".game_error_btn").show();
    })
    .done(function (res) {
      $("#" + textpos + "-Balance").text("");
      if (res.success == 0) {
        if (wallet != "Master") {
          $("#transmodal .game_error a").prop("disabled", false).css({ "cursor": "pointer", "opacity": "1" });
        }
        if (res.data) {
          var balance = res.data.Balance ? res.data.Balance : "失敗";
        } else {
          var balance = "失敗";
        }
        $("#" + textpos + "-Balance").text(balance);
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          case -2:
          case -3:
          case -92:
            $("#" + textpos + "-Balance").text(res.msg);
            $(".game_error").hide();
            $(".game_error_btn").show();
            break;
          default:
            $("#" + textpos + "-Balance").text("失敗");
            $(".game_error").hide();
            $(".game_error_btn").show();
            break;
        }
      }
    });
}
// 20201006 電腦版遊戲錢轉點  wallet 目標錢包  amount 金額  gameg 給自建大廳用
function play_transfer(wallet, amount, gameg2 = "F", gamecode2 = "F") {
  var _gameurl = "";
  if (gameg2 != "F") {
    _gameurl = "/GameLobby?g=" + gameg2 + "&c=" + gamecode2;
  } else {
    _gameurl = "/GameLobby?g=" + wallet;
  }
  // gameg = gamecode = gamecode1 = "";

  let fromhall = $("#fromhall").val();

  if (fromhall == "Master") {
    transferInModal({from: fromhall, to: wallet, amount: amount, gameurl: _gameurl})
  } else {
    let toMaster = transferInModal({from: fromhall, to: "Master", amount: amount});

    $.when(toMaster).done((res) => {
      if (res.success == 0) {
        let toHall = transferInModal({from: "Master", to: wallet, amount: amount, gameurl: _gameurl});
        let updateHall = gettbalance(fromhall);
        $.when(toHall).done((res) => updateHall);
      }
    });
  }
}

function transferInModal(transfer) {
  // fromhall, toHall, amount, _gameurl = null, IsAllToHall = "N"

  if (transfer.gameurl != null && transfer.IsAllToHall == "Y" && transfer.amount <= 0) {
    swal({
      title: "轉點成功",
      text: "",
      type: "success",
      confirmButtonText: "進入遊戲",
    }).then((result) => {
      $("#tramount").val("");

      if (transfer.gameurl != null) {
        $("#modal-transfer").fadeOut();
        window.open(transfer.gameurl);
      }
    });
    return false;
  }

  let _data = `a=saveTransfer&from=${transfer.from}&to=${transfer.to}&amount=${transfer.amount}&IsAllToHall=${transfer.IsAllToHall}`;

  return $.ajax({
    url: "../../member_act",
    type: "POST",
    data: _data,
    dataType: "json",
  })
  .fail(function (res) {
    swal("轉點失敗", "", "error").then(function () {
      $("#tramount").val("");
      $("#tringtext").hide();
      $('#modal-transfer').removeClass("modal-loading")
    });
  })
  .done(function (res) {
    if (res.success == 0) {
      if (transfer.to == "Master") {
        return false;
      }

      swal(res.msg, "", "success").then(function () {
        $("#tramount").val("");

        if (transfer.gameurl != null) {
          $("#modal-transfer").fadeOut();
          window.open(transfer.gameurl);
        }
      });
    } else {
      switch (res.success) {
        case -99999:
        case -9999:
          if (logintype) {
            logintype = false;
            swal(res.msg, "", "error").then(function () {
              location.href = "/logout";
            });
          }
          break;
        default:
          if (transfer.IsAllToHall == "Y" && transfer.gameurl != null) {
            swal({
              title: "轉點成功",
              text: "",
              type: "success",
              confirmButtonText: "進入遊戲",
            }).then(function () {
              $("#tramount").val("");
              $("#modal-transfer").fadeOut();
              window.open(transfer.gameurl);
            });
          } else {
            swal(res.msg, "", "error").then(function () {
              $("#tramount").val("");
              $("#tringtext").hide();
              $('#modal-transfer').removeClass("modal-loading")
            });
          }
          break;
      }
    }
  });
}

function memverify() {
  let vercode = $('#verifyform input[name="Verificationcode"]').val();

  $.ajax({
    url: "/registration_act",
    type: "POST",
    data: {
      a: "verify",
      VCode: vercode,
    },
    dataType: 'json'
  })
  .fail(function (res) {
    //btn_load.stop();
    swal("出現問題，請稍後再試!", "", "error");
  })
  .done(function (res) {
    if (res.success == 0) {
      swal(res.msg, "", "success").then(function () {
        location.href = './';
      });
    } else {
      swal(res.msg, "", "error");
    }
  });
}

function audioLoginSuccess() {
  let sound = new Audio("/media/alert.mp3");
  sound.play();
}

function loadFile(event) {
  let upload_loading = $('#upload_loading').attr('src')
  $(`#${event.target.id}OutPut`).attr('src', upload_loading);

  let file = event.target.files[0];
  let data = new FormData();
  data.append("a", "upLoadImage2");
  data.append("Image", file);

  if (!file) {
    swal("未上傳圖片", "", "warning");
    return false;
  }

  let maxsize = 10*1024*1024;
  if (file.size > maxsize) {
    swal(`圖片不得超過10M`, "", "error")
    return false;
  }

  $.ajax({
    url: '/member_act',
    type: 'POST',
    data: data,
    dataType: 'json',
    cache: false,
    contentType: false,
    processData: false
  }).fail(function (jqXHR, textStatus, errorThrown) {
    $('.swal2-cancel').show();
    swal("出現問題，請稍後再試!", `readyState: ${jqXHR.readyState}, status: ${jqXHR.status}`, "error");
  }).done(function (res) {
    $('.swal2-cancel').show()
    if (res.success == 0) {
      $(event.target).prev('input').val(res.data.filename)
      ImagePreview.show(`${event.target.id}OutPut`, file, res.data.url);
    } else {
      swal(res.msg, "", "error");
      $(event.target).prev('input').val("");
      $(event.target).val("")
      $(`#${event.target.id}OutPut`).attr('src', '')
    }
  })
}

  //header active
  let pathsName = $("#pathName").val()
  $(`.keng-item > a`).removeClass('active')
  $(`.nav-${pathsName} > a`).addClass("active")

function resetVideoField(target) {
  $(target).val("");
  $(target).prev('input').val("");
  $(`#${target.id}OutPut`).attr('src', '').show();
  $(`#${target.id}OutPut`).next("video").find("source").attr('src', '');
  $(`#${target.id}OutPut`).next("video").hide();
}

function loadFile_video(event) {
  let file = event.target.files[0];
  if (!file) {
    swal("未上傳影片", "", "warning");
    return false;
  }

  let maxsize = 50 * 1024 * 1024;
  if (file.size > maxsize) {
    swal(`影片不得超過 ${Math.floor(maxsize / 1024 / 1024)}M`, "請縮短影片長度或將錄影畫質調整為 1080p", "error");
    resetVideoField(event.target);
    return false;
  }

  let upload_loading = $('#upload_loading').attr('src')
  $(`#${event.target.id}OutPut`).attr('src', upload_loading);
  $(`#${event.target.id}OutPut`).show().next("video").hide();

  let data = new FormData();
  data.append("a", "upLoadImage2");
  data.append("Video", file);

  $.ajax({
    url: '/member_act',
    type: 'POST',
    data: data,
    dataType: 'json',
    cache: false,
    contentType: false,
    processData: false
  }).fail(function (jqXHR, textStatus, errorThrown) {
    $('.swal2-cancel').show();
    resetVideoField(event.target);
    swal("出現問題，請稍後再試!", `readyState: ${jqXHR.readyState}, status: ${jqXHR.status}, size: ${file.size} bytes`, "error");
  }).done(function (res) {
    $('.swal2-cancel').show()
    if (res.success == 0) {
      $(event.target).prev('input').val(res.data.filename)
      $(`#${event.target.id}OutPut`).next("video").find("source").attr('src', res.data.url);
      $(`#${event.target.id}OutPut`).hide().next("video").show();
      const mediaElem = document.querySelector("video");
      mediaElem.load();

    } else {
      swal(res.msg, "", "error");
      resetVideoField(event.target);

    }
  })
}

$('#checkinInto').on('click', function(){
  $('#Checkin').show()
  $('body').addClass('overflow')
  $(".q-btn").prop("disabled", true).addClass("disabled");
  $(".q-btn").removeClass('active');
  $("#depositAmount").html('載入中');
  $("#betAmount").html('載入中');
  $(".q-btn__content").text('載入中');
  for (i = 0; i < 7; i++) {
    $(`.signProgress_container li:nth-child(${i+1})`).removeClass('sign');
  }

  checkinStatus();
})

function checkinStatus() {
  $.ajax({
    url: "/checkin_act",
    type: "POST",
    data: "a=checkinStatus",
    dataType: "json",
  })
  .fail(function (res) {
    console.log("fail");
    swal(res.msg, "", "error");
  })
  .done(function (res) {
    if (res.success == 0) {
      let data = res.data;
      content =  document.querySelector('.decmimal').children.outerHTML;
      $("#depositAmount").html(data.userDepositAmount_Today);
      $("#betAmount").html(data.userBetAmount_Today);
      $(".q-btn__content").text(data.statusMessage);
      $(".decmimal").html(content);
      for (i = 0; i < data.CheckinTimes.checkedTimes; i++) {
        $(`.signProgress_container li:nth-child(${i+1})`).addClass('sign');
      }
      if (data.status == 1 || data.status == 2) {
        $("button").data("method", data.status);
        $(".q-btn").addClass('active');
        $(".q-btn").prop('disabled', false).removeClass("disabled");
      }
    } else {
      switch (res.success) {
      case -99999:
      case -9999:
        if (logintype) {
          logintype = false;
          swal(res.msg, '', 'error').then(function () {
            location.href = './logout';
            $('.loading_block').show();
          })
        }
          break;
      default:
        swal(res.msg, '', 'error')
        break;
      }
    }
  });
}

$('.q-btn').on('click', function() {
  $(".q-btn").prop("disabled", true).addClass("disabled");
  $(".q-btn").removeClass('active');
  $("#depositAmount").html('載入中');
  $("#betAmount").html('載入中');
  $(".q-btn__content").text('載入中');

  checkin_act();
})

function checkin_act() {
  let method = $(".q-btn").data("method");
  if (method == 1) method = 'CheckIn';
  if (method == 2) method = 'getBonus';

  $.ajax({
    url: "/checkin_act",
    type: "POST",
    data: "a=" + method,
    dataType: "json",
  })
  .fail(function (res) {
    console.log("fail");
    swal(res.msg, "", "error");
  })
  .done(function (res) {
    if (res.success == 0) {
      swal(res.msg, "", 'success');
      $("#checkinInto").click();
    } else {
      switch (res.success) {
      case -99999:
      case -9999:
        if (logintype) {
          logintype = false;
          swal(res.msg, '', 'error').then(function () {
              location.href = './logout';
              $('.loading_block').show();
          })
        }
        break;
      default:
        swal(res.msg, '', 'error')
        $("#checkinInto").click();
        break;
      }
    }
  });
}

function getUserBalanceList() {
  $.ajax({
    url: "/member_act",
    type: "POST",
    data: "a=getBalanceList",
    dataType: "json",
  }).fail(function (jqXHR, textStatus, errorThrown) {
    $('.swal2-cancel').show();
    swal("出現問題，請稍後再試!", `readyState: ${jqXHR.readyState}, status: ${jqXHR.status}`, "error");
  }).done(function (res) {
    if (res.success == 0) {
      let content = "";
      let list = res.data.BalanceList
      // let active_item = $("#fromhall").val();
      let hall = $("#fromhall").val();

      list.forEach((item) => {
        let status = item.HallCode == hall ? "active" : "";
        let bind = "";
        if (item.Balance == "not_open") {
          status = "disabled"
          item.Balance = "未開通";
        } else {
          bind = "onclick='bindTransferHall(this)'"
        }

        if ($("#trhall").val() != item.HallCode) {
          content += `<li class="dropdown-menu__item item ${status}" data-hall="${item.HallCode}" ${bind}><span class="hall">${item.HallName}</span><span class="balance">${item.Balance}</span></li>`
        }
      });

      $(".dropdown-menu").removeClass("loading").html(content);
      bindDropdownMenuItem();
    }
  })
}

function bindDropdownMenuItem() {
  $(".dropdown-menu__item").not(".disabled").click(function() {
    let dropdown = $(this).closest('.dropdown');
    let dropdown_menu = dropdown.find(".dropdown-menu");
    let dropdown_caret = dropdown.find(".dropdown-caret");

    if (dropdown_menu.hasClass('loading')) {
      return false;
    }

    dropdown_menu.fadeOut();
    dropdown_caret.removeClass("fa-caret-down").addClass("fa-caret-right");

    dropdown.find(".dropdown-menu__item").removeClass("active");
    $(this).addClass("active")
  })
}

function bindTransferHall(e) {
  $("#fromhall").val($(e).data('hall'));
  $(".fromhall_block .hall").text($(e).find('.hall').text())
  $("#Master-Balance").text($(e).find('.balance').text());
}

$("#transmodal-refresh").click(function() {
  $("#Master-Balance").text("...載入中...")
  let hall = $("#fromhall").val();
  $.ajax({
    url: "../../member_act",
    type: "POST",
    data: `a=getBalance&h=${hall}`,
    dataType: "json",
  })
  .fail(function (res) {
    console.log("fail");
  })
  .done(function (res) {
    // console.log(res);
    if (res.success == 0) {
      $("#Master-Balance").text(res.data.Balance);
    } else {
      switch (res.success) {
        case -99999:
        case -9999:
          if (logintype) {
            logintype = false;
            swal(res.msg, "", "error").then(function () {
              location.href = "/logout";
            });
          }
          break;
        default:
          swal(res.msg, "", "error");
          break;
      }
    }
  });
})

function allInGame() {
  $("#transmodal .game_error a").prop("disabled", true).css({ "cursor": "not-allowed", "opacity": "0.7" });
  $('#tringtext').show();
  $('#modal-transfer').addClass("modal-loading");

  $.ajax({
    url: '../../member_act',
    type: 'POST',
    data: 'a=oneclicktransfer',
    dataType: 'json'
  }).fail(function (res) {
    swal("出現問題，請稍後再試!", "", "error");
    $("#transmodal .game_error a").prop("disabled", false).css({ "cursor": "pointer", "opacity": "1" });
    $('#tringtext').hide();
    $('#modal-transfer').removeClass("modal-loading");
  }).done(function (res) {
    if (res.success == -99999 || res.success == -9999 || res.success == -2) {
      $("#transmodal .game_error a").prop("disabled", false).css({ "cursor": "pointer", "opacity": "1" });
      $('#tringtext').hide();
      $('#modal-transfer').removeClass("modal-loading");
      if (res.success == -2) {
        swal(res.msg, '', 'error');
      } else {
        swal({
          text: res.msg,
          type: 'error',
        }).then(function () {
          location.href = '/logout';
        })
      }
      return;
    }

    let Masterbalance = gettbalance("Master");
    $.when(Masterbalance).done((res) => {
      if (res.success != 0) {
        $("#transmodal .game_error a").prop("disabled", false).css({ "cursor": "pointer", "opacity": "1" });
        $('#tringtext').hide();
        $('#modal-transfer').removeClass("modal-loading");
        return false;
      }

      let trhall = $('#trhall').val();
      let gamecode = $("#notrtogame").data("gamecode");
      let _gameurl = "";
      if (gamecode) {
        _gameurl = '/GameLobby?g=' + trhall + '&c=' + gamecode;
      } else {
        _gameurl = '/GameLobby?g=' + trhall;
      }

      transferInModal({from: "Master", to: trhall, amount: res.data.Balance, gameurl: _gameurl, IsAllToHall: "Y"});
    })
  })
}

function getPhoneVerify(e) {
  $(e).prop('disabled', true).css({'opacity':'0.5', 'cursor': 'not-allowed'});
  let username = $(e).closest('form').find('.useraccount').val();
  let actphonenum = $(e).closest('form').find('.activephone').val();

  $.ajax({
    url: '/registration_act',
    type: 'POST',
    data: "a=operateVerify",
    dataType: 'json'
  }).fail(function(res){
    $(e).prop('disabled', false).css({'opacity':'1', 'cursor': 'pointer'});
    console.log('sendactivation code error');
  }).done(function(res) {
    $(e).prop('disabled', false).css({'opacity':'1', 'cursor': 'pointer'});
    if (res.success == 0) {
        swal(res.msg, "", 'success');
    } else {
      switch (res.success) {
        case -99999:
        case -9999:
          if (logintype) {
            logintype = false;
            swal(res.msg, "", "error").then(function () {
              location.href = "/logout";
            });
          }
          break;
        default:
          swal(res.msg, "", "error");
          break;
      }
    }
  });
}
$('.noJoint').click(function () {
  Swal.fire('敬請期待', '', 'info')
});


$("#verifyform").validate({
  // debug: true,
  focusCleanup: true,
  onkeyup: false,
  onfocusout: function (element) {
      $(element).valid()
  },
  rules: {
      Verificationcode: {
          required: true,
      },
  },
  errorPlacement: function (error, element) {
      var elemm = $('#verifyform #' + element[0].name + '-error');
      elemm.empty();
      error.appendTo( elemm );
      elemm.show();
  },
  messages: {
      Verificationcode: {
          required: "請輸入驗證碼",
      },
  },
  submitHandler: function () {
      memverify();
  }
});

function isnull(val) {
  var str = val.replace(/(^\s*)|(\s*$)/g, '');
  if (str == '' || str == undefined || str == null){
      return true;
  }
}

function isAccount(val) {
  let str = val.replace(/(^\s*)|(\s*$)/g, '');
  if (str == '' || str == undefined || str == null) {
      return "請輸入帳號";
  } 
  if (str.length < 6 || str.length > 20) {
      return "僅限6到20個英文及數字。(AZ，az，0-9)";
  }
}

function isPhone(val) {
  let str = val.replace(/(^\s*)|(\s*$)/g, '');
  // 台灣: 09xxxxxxxx (10位), 馬來西亞: 01xxxxxxxx (10-11位), 香港: xxxxxxxx (8位), 中國: 1xxxxxxxxxx (11位)
  let mobile = /^(09[0-9]{8}|01[0-9]{8,9}|[2-9][0-9]{7}|1[3-9][0-9]{9})$/;
  if (str == '' || str == undefined || str == null) {
      return "請輸入手機號碼";
  }
  if (str.length < 8 || str.length > 11) {
      return "手機號碼僅限8到11個數字";
  }
  if (!mobile.test(str)) {
      return "請輸入有效的手機號碼!";
  }
}

function isPassword(val) {
  let str = val.replace(/(^\s*)|(\s*$)/g, '');
  if (str == '' || str == undefined || str == null) {
      return "請輸入密碼";
  } 
  if (str.length < 6 || str.length > 20) {
      return "僅限6到20個英文及數字。(AZ，az，0-9)";
  }
}

function isChkPassword(val) {
  let str = val.replace(/(^\s*)|(\s*$)/g, '');
  if (str == '' || str == undefined || str == null) {
      return "請再次輸入密碼";
  } 
  if (str.length < 6 || str.length > 20) {
      return "僅限6到20個英文及數字。(AZ，az，0-9)";
  }
}

function showBonusButton(BonusID) { 
  $.ajax({
    url: "/member_act.php",
    type: "POST",
    data: "a=showBonusButton&BonusID=" + BonusID,
    dataType: "json",
  })
  .fail(function (res) {
    console.log("get data failed");
  })
  .done(function (res) {

    if (res.success == 0) {
      $(".bonus-remark").text("").hide();
      $('.bonus-btn').text("立即申請").show().prop('disabled', false);
    } else {
        if (res.remark) {
            let remark = "";
            for (let text of res.remark) {
                remark += `<span><i class="fas fa-times-circle"></i>${text}</span>`
            }
            $(".bonus-remark").html(remark).show();
        }

        if (res.success == -100) {
            $('.bonus-service').text(res.msg).show()
        } else {
            $('.bonus-btn').text(res.msg).show().prop('disabled', true);
        }
    }
  });
}
//取得優惠按鈕
function getBonusButton(BonusID) {
  $('.bonus-btn').show().attr('disabled', 'disabled');

  $.ajax({
    url: "/member_act.php",
    type: "POST",
    data: "a=getBonusButton&BonusID=" + BonusID,
    dataType: "json",
  })
  .fail(function (res) {
    console.log("get data failed");
  })
  .done(function (res) {
    if (res.success == 0) {
      swal(res.msg, "", "success");
    } else {
      swal(res.msg, "", "error");
    }
  });
}

function getBonus(event, BonusID, DownlineUserID = null) {
  $(event).prop('disabled', true);
  $.ajax({
    url: '/member_act',
    type: 'POST',
    data: {
      a: 'getBonusButton',
      BonusID:  BonusID,
      DownlineUserID: DownlineUserID,
      ShowType: "ShowReferral"
    },
    dataType: 'json'
  }).fail(function(res){
    $(event).prop('disabled', false);
    swal("出現問題，請稍後再試!", "", "error");
  }).done(function(res) {
    $(event).prop('disabled', false);
    if (res.success == 0) {
      swal(res.msg, "", 'success');
    } else {
      let remark = "";
      if (res.remark) {
        for (let text of res.remark) {
            remark += `<span><i class="fas fa-times-circle" style="margin-right: 5px;"></i>${text}</span>`
        }
      }
      swal(res.msg, remark, 'error');
    }

    DownlineUserID > 0 && getSharedbonus();
  })
}